// source: pbtypes/tools/cloud_api/feature_flags.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_tools_cloud_api_enums_pb = require('../../../pbtypes/tools/cloud_api/enums_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_enums_pb);
var pbtypes_tools_cloud_api_org_permission_pb = require('../../../pbtypes/tools/cloud_api/org_permission_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_org_permission_pb);
goog.exportSymbol('proto.cloud_api.FeatureFlagRequest', null, global);
goog.exportSymbol('proto.cloud_api.FeatureFlags', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.FeatureFlags = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.cloud_api.FeatureFlags, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.FeatureFlags.displayName = 'proto.cloud_api.FeatureFlags';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.FeatureFlagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.FeatureFlagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.FeatureFlagRequest.displayName = 'proto.cloud_api.FeatureFlagRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.FeatureFlags.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.FeatureFlags.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.FeatureFlags} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlags.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleTeleoperation: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
automaticFileUploadPage: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
liveStreaming: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
axonMediaIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
missionsPage: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
axonRespondIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
viewOfflineSettings: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
configureObstacleMargin: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
droInternal: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
annotations: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
cloudInspectPage: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
missionMediaViewer: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
automaticCloudPhotogrammetry: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
dockLocationUpdate: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
disableTeleopLandingPrompt: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
droTeleopRunMissionJson: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
hideLandNowDuringRtd: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
remoteVideoApiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
allowTwilightFlight: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
allowBacktrackingRtx: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
cloudOta: jspb.Message.getBooleanFieldWithDefault(msg, 40, false),
teleopDebugMenu: jspb.Message.getBooleanFieldWithDefault(msg, 41, false),
qosSkybusChannelSetting: jspb.Message.getBooleanFieldWithDefault(msg, 42, false),
postRefactorMissionEditor: jspb.Message.getBooleanFieldWithDefault(msg, 43, false),
networkDebuggingTools: jspb.Message.getBooleanFieldWithDefault(msg, 46, false),
fullHeightVideoEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 47, false),
navHeightAboveGroundEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 49, false),
internalThemeToggle: jspb.Message.getBooleanFieldWithDefault(msg, 51, false),
customerCustomMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 53, false),
showVehicleFaultsTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 63, false),
showVpsInfo: jspb.Message.getBooleanFieldWithDefault(msg, 66, false),
teleopArV2: jspb.Message.getBooleanFieldWithDefault(msg, 67, false),
missionControlApi: jspb.Message.getBooleanFieldWithDefault(msg, 68, false),
surfaceScanMissions: jspb.Message.getBooleanFieldWithDefault(msg, 71, false),
showAprilTagSettings: jspb.Message.getBooleanFieldWithDefault(msg, 72, false),
showRangeLimitSettings: jspb.Message.getBooleanFieldWithDefault(msg, 80, false),
siteMapper: jspb.Message.getBooleanFieldWithDefault(msg, 85, false),
showBandSelectionSettings: jspb.Message.getBooleanFieldWithDefault(msg, 86, false),
flyNowNoAutomaticRunModeSwitching: jspb.Message.getBooleanFieldWithDefault(msg, 87, false),
arVideoSync: jspb.Message.getBooleanFieldWithDefault(msg, 88, false),
missionResults3dViewer: jspb.Message.getBooleanFieldWithDefault(msg, 89, false),
automaticNcpgPhotogrammetry: jspb.Message.getBooleanFieldWithDefault(msg, 92, false),
executiveActionHotkeys: jspb.Message.getBooleanFieldWithDefault(msg, 93, false),
vehicleTypeBasedAxonSessions: jspb.Message.getBooleanFieldWithDefault(msg, 94, false),
alwaysShowCameraSettings: jspb.Message.getBooleanFieldWithDefault(msg, 99, false),
teleopWaypointCommands: jspb.Message.getBooleanFieldWithDefault(msg, 101, false),
propGuardsEnablement: jspb.Message.getBooleanFieldWithDefault(msg, 108, false),
remotePilotApiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 111, false),
showViewFlightDeckButton: jspb.Message.getBooleanFieldWithDefault(msg, 112, false),
twilightModeFastFlight: jspb.Message.getBooleanFieldWithDefault(msg, 113, false),
standaloneMapPage: jspb.Message.getBooleanFieldWithDefault(msg, 114, false),
lostCommsTimeoutSettingTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 116, false),
teleopFastFlight: jspb.Message.getBooleanFieldWithDefault(msg, 117, false),
allowEditAdsbSettings: jspb.Message.getBooleanFieldWithDefault(msg, 119, false),
showTeleopIdleModal: jspb.Message.getBooleanFieldWithDefault(msg, 121, false),
skydioExtend: jspb.Message.getBooleanFieldWithDefault(msg, 122, false),
supportMenuV2: jspb.Message.getBooleanFieldWithDefault(msg, 123, false),
geofenceEnforcementInCloud: jspb.Message.getBooleanFieldWithDefault(msg, 125, false),
teleopThirdPersonView: jspb.Message.getBooleanFieldWithDefault(msg, 129, false),
showTeleopCircularBatteryWidget: jspb.Message.getBooleanFieldWithDefault(msg, 132, false),
structureAnnotationsApi: jspb.Message.getBooleanFieldWithDefault(msg, 134, false),
ownOrgGroups: jspb.Message.getBooleanFieldWithDefault(msg, 138, false),
teleopCommandeeringV2: jspb.Message.getBooleanFieldWithDefault(msg, 139, false),
ncpgPhotogrammetryUseTensorRtFlowModel: jspb.Message.getBooleanFieldWithDefault(msg, 142, false),
showFaaMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 143, false),
sitesStructureEditor: jspb.Message.getBooleanFieldWithDefault(msg, 147, false),
multiMissionFlightTester: jspb.Message.getBooleanFieldWithDefault(msg, 148, false),
x10EoCameraControlsParityInTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 154, false),
noObstacleAvoidanceInTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 155, false),
vpsMapDatamodelTransitionReadFromNew: jspb.Message.getBooleanFieldWithDefault(msg, 162, false),
vpsMapDatamodelTransitionWriteToBoth: jspb.Message.getBooleanFieldWithDefault(msg, 163, false),
editOrgFlightPolicy: jspb.Message.getBooleanFieldWithDefault(msg, 164, false),
teleopWheelZoom: jspb.Message.getBooleanFieldWithDefault(msg, 165, false),
multizoneSiteGeofences: jspb.Message.getBooleanFieldWithDefault(msg, 166, false),
teleopBitrateSlider: jspb.Message.getBooleanFieldWithDefault(msg, 168, false),
ridFeatureDisabled: jspb.Message.getBooleanFieldWithDefault(msg, 171, false),
safeLandingPoints: jspb.Message.getBooleanFieldWithDefault(msg, 174, false),
teleopBoostMode: jspb.Message.getBooleanFieldWithDefault(msg, 177, false),
teleopCrawlMode: jspb.Message.getBooleanFieldWithDefault(msg, 178, false),
showOperationsAreaMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 180, false),
barometerHeightMode: jspb.Message.getBooleanFieldWithDefault(msg, 183, false),
graphiqlViewer: jspb.Message.getBooleanFieldWithDefault(msg, 186, false),
enableOrbitToPoiRfd: jspb.Message.getBooleanFieldWithDefault(msg, 187, false),
disableCloudConfigSignatureVerification: jspb.Message.getBooleanFieldWithDefault(msg, 188, false),
isOnpremOrg: jspb.Message.getBooleanFieldWithDefault(msg, 189, false),
enableMapVehicleFollowiing: jspb.Message.getBooleanFieldWithDefault(msg, 192, false),
teleopTelemetryHeadingAndGimbalPitch: jspb.Message.getBooleanFieldWithDefault(msg, 194, false),
mediaPageKindDropdown: jspb.Message.getBooleanFieldWithDefault(msg, 195, false),
teleopActionsToolbar: jspb.Message.getBooleanFieldWithDefault(msg, 196, false),
enableDockLandingAr: jspb.Message.getBooleanFieldWithDefault(msg, 199, false),
teleopNavSourceInfoHealth: jspb.Message.getBooleanFieldWithDefault(msg, 201, false),
enableAxonMarkersRfd: jspb.Message.getBooleanFieldWithDefault(msg, 202, false),
enableFpvOnMap: jspb.Message.getBooleanFieldWithDefault(msg, 203, false),
gimbalPitchResetShortcut: jspb.Message.getBooleanFieldWithDefault(msg, 206, false),
r47ShowMissionPlanners: jspb.Message.getBooleanFieldWithDefault(msg, 208, false),
rfdControllerMaxSpeedParity: jspb.Message.getBooleanFieldWithDefault(msg, 209, false),
enableArStreetOverlays: jspb.Message.getBooleanFieldWithDefault(msg, 210, false),
enableRfdHudCompass: jspb.Message.getBooleanFieldWithDefault(msg, 213, false),
enableRfdHudAirspeedAltitude: jspb.Message.getBooleanFieldWithDefault(msg, 216, false),
moveVehicleLaunchModalVideoFeed: jspb.Message.getBooleanFieldWithDefault(msg, 220, false),
enableDockTransitPoint: jspb.Message.getBooleanFieldWithDefault(msg, 222, false),
usePathfinderFlyToPointRfd: jspb.Message.getBooleanFieldWithDefault(msg, 227, false),
mediaAvailableForFlightAlert: jspb.Message.getBooleanFieldWithDefault(msg, 228, false),
dfrStockSettings: jspb.Message.getBooleanFieldWithDefault(msg, 232, false),
customer2CustomMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 234, false),
rfdConnectivitySettingsTab: jspb.Message.getBooleanFieldWithDefault(msg, 236, false),
missionEditorNightAutonomy: jspb.Message.getBooleanFieldWithDefault(msg, 237, false),
rfdParachuteAttachmentUi: jspb.Message.getBooleanFieldWithDefault(msg, 238, false),
showCloudSimulatorControls: jspb.Message.getBooleanFieldWithDefault(msg, 239, false),
missionSharingCustomerPortal: jspb.Message.getBooleanFieldWithDefault(msg, 240, false),
useImprovedFlightStatusWorkflow: jspb.Message.getBooleanFieldWithDefault(msg, 243, false),
rfdTelemetryStats: jspb.Message.getBooleanFieldWithDefault(msg, 247, false),
showOperationsAreaInternalMapboxStyles: jspb.Message.getBooleanFieldWithDefault(msg, 248, false),
activateStrobeLightsOnLaunchRfd: jspb.Message.getBooleanFieldWithDefault(msg, 249, false),
missionDocumentsApi: jspb.Message.getBooleanFieldWithDefault(msg, 250, false),
fleetPageSdCardFormatting: jspb.Message.getBooleanFieldWithDefault(msg, 251, false),
enableMultidroneOperations: jspb.Message.getBooleanFieldWithDefault(msg, 252, false),
controlKeyDragWaypointVertical: jspb.Message.getBooleanFieldWithDefault(msg, 254, false),
showTerrainAndBldgsToggleInFleetPage: jspb.Message.getBooleanFieldWithDefault(msg, 255, false),
showOverlappingDockWifiChannelsFleetPage: jspb.Message.getBooleanFieldWithDefault(msg, 259, false),
showInternalMapboxStyles3: jspb.Message.getBooleanFieldWithDefault(msg, 261, false),
fixedLocationRid: jspb.Message.getBooleanFieldWithDefault(msg, 262, false),
teleopPilotKeepAlive: jspb.Message.getBooleanFieldWithDefault(msg, 264, false),
enableRtkSupport: jspb.Message.getBooleanFieldWithDefault(msg, 272, false),
cityCustomerMapboxMapStyles: jspb.Message.getBooleanFieldWithDefault(msg, 274, false),
linkLossAlertLevelCaution: jspb.Message.getBooleanFieldWithDefault(msg, 276, false),
enableSetupFlights: jspb.Message.getBooleanFieldWithDefault(msg, 288, false),
europeanUnion: jspb.Message.getBooleanFieldWithDefault(msg, 289, false),
enableCreateMarkerInteractionRfd: jspb.Message.getBooleanFieldWithDefault(msg, 292, false),
dronesenseIntegrationSetup: jspb.Message.getBooleanFieldWithDefault(msg, 293, false),
enableC18MicrohardOfflineConfiguration: jspb.Message.getBooleanFieldWithDefault(msg, 295, false),
customMapLayersExternal: jspb.Message.getBooleanFieldWithDefault(msg, 296, false),
customMapLayersInternal: jspb.Message.getBooleanFieldWithDefault(msg, 297, false),
filterMarkersInRfdSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 303, false),
dfrCommand: jspb.Message.getBooleanFieldWithDefault(msg, 305, false),
missionDetailsAboveSkillsSwitcher: jspb.Message.getBooleanFieldWithDefault(msg, 306, false),
multiBatteryMissions: jspb.Message.getBooleanFieldWithDefault(msg, 307, false),
swapToX10DockCamOnLanding: jspb.Message.getBooleanFieldWithDefault(msg, 308, false),
enableRfdDedrone: jspb.Message.getBooleanFieldWithDefault(msg, 310, false),
enableRfdAdsbRecording: jspb.Message.getBooleanFieldWithDefault(msg, 311, false),
missionEditorShowInternalNavigationModeOptions: jspb.Message.getBooleanFieldWithDefault(msg, 313, false),
enableDfrCommandPhaseTwoUi: jspb.Message.getBooleanFieldWithDefault(msg, 314, false),
enableDfrCommandPhaseTwoPointFiveUi: jspb.Message.getBooleanFieldWithDefault(msg, 315, false),
enableDfrCommandPhaseThreeUi: jspb.Message.getBooleanFieldWithDefault(msg, 316, false),
enableDfrOrgBasedLivekitRoom: jspb.Message.getBooleanFieldWithDefault(msg, 317, false),
x10DefaultsForGpsInitWaypoint: jspb.Message.getBooleanFieldWithDefault(msg, 318, false),
enableProperArSync: jspb.Message.getBooleanFieldWithDefault(msg, 324, false),
enableRfdViewLookatPoint: jspb.Message.getBooleanFieldWithDefault(msg, 329, false),
enableRfdSetLookatPoint: jspb.Message.getBooleanFieldWithDefault(msg, 330, false),
simulateRemoteOnPremOrg: jspb.Message.getBooleanFieldWithDefault(msg, 333, false),
multiOrgUsersRpic: jspb.Message.getBooleanFieldWithDefault(msg, 337, false),
markersApi: jspb.Message.getBooleanFieldWithDefault(msg, 339, false),
allowDirectDeviceAdoption: jspb.Message.getBooleanFieldWithDefault(msg, 342, false),
enableDocklessSites: jspb.Message.getBooleanFieldWithDefault(msg, 343, false),
enableTeleopInIframe: jspb.Message.getBooleanFieldWithDefault(msg, 347, false),
enableDfrDockviewLayout: jspb.Message.getBooleanFieldWithDefault(msg, 348, false),
enableCustomerManagedSessionLengths: jspb.Message.getBooleanFieldWithDefault(msg, 349, false),
enableDispatchRespondHere: jspb.Message.getBooleanFieldWithDefault(msg, 352, false),
deploymentEngineerMissionsInternal: jspb.Message.getBooleanFieldWithDefault(msg, 355, false),
setTakePhotoWaitForFocusToConverge: jspb.Message.getBooleanFieldWithDefault(msg, 357, false),
enableValidationOfOnDemandMission: jspb.Message.getBooleanFieldWithDefault(msg, 360, false),
enableAxonWatchMeDemo: jspb.Message.getBooleanFieldWithDefault(msg, 361, false),
enableIncidentsStateUi: jspb.Message.getBooleanFieldWithDefault(msg, 363, false),
enablePlanningAroundGeofencesFlyToPointRfd: jspb.Message.getBooleanFieldWithDefault(msg, 364, false),
hiveChannelConflictPrevention: jspb.Message.getBooleanFieldWithDefault(msg, 368, false),
unifiedMissionEditor: jspb.Message.getBooleanFieldWithDefault(msg, 370, false),
missionsCloudToController: jspb.Message.getBooleanFieldWithDefault(msg, 371, false),
enableWaypointMetricsWorkflow: jspb.Message.getBooleanFieldWithDefault(msg, 372, false),
enablePropellerTypeSpecification: jspb.Message.getBooleanFieldWithDefault(msg, 373, false),
improvedLandingButtons: jspb.Message.getBooleanFieldWithDefault(msg, 374, false),
enableCancelIncidentResponseModal: jspb.Message.getBooleanFieldWithDefault(msg, 376, false),
displayCellularCarrierInfo: jspb.Message.getBooleanFieldWithDefault(msg, 378, false),
enableUnsupportedBrowserWarning: jspb.Message.getBooleanFieldWithDefault(msg, 379, false),
enableExtraAccessModes: jspb.Message.getBooleanFieldWithDefault(msg, 380, false),
enableCustomMapLayersBackend: jspb.Message.getBooleanFieldWithDefault(msg, 381, false),
reverseGeocodeMarkersOnRead: jspb.Message.getBooleanFieldWithDefault(msg, 383, false),
editOrgFlightPolicyNondocked: jspb.Message.getBooleanFieldWithDefault(msg, 385, false),
sitesImprovements525: jspb.Message.getBooleanFieldWithDefault(msg, 387, false),
cloudRel5UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 388, false),
showFileReleaseUi: jspb.Message.getBooleanFieldWithDefault(msg, 389, false),
useX10rev1AndUnknownAcceleratedPropWearAlert: jspb.Message.getBooleanFieldWithDefault(msg, 390, false),
useX10rev2AcceleratedPropWearAlert: jspb.Message.getBooleanFieldWithDefault(msg, 391, false),
rtkEarlyAccessProgram: jspb.Message.getBooleanFieldWithDefault(msg, 392, false),
newCloudNavigation: jspb.Message.getBooleanFieldWithDefault(msg, 393, false),
apiObservability: jspb.Message.getBooleanFieldWithDefault(msg, 394, false),
newIntegrationsUi: jspb.Message.getBooleanFieldWithDefault(msg, 395, false),
updatedCreateOrganizationModal: jspb.Message.getBooleanFieldWithDefault(msg, 397, false),
cloudSimAutomaticSiteSetup: jspb.Message.getBooleanFieldWithDefault(msg, 398, false),
enablePostFlightReports: jspb.Message.getBooleanFieldWithDefault(msg, 402, false),
enableDfrOutcomesSurvey: jspb.Message.getBooleanFieldWithDefault(msg, 406, false),
rfdStreamlineNotifications: jspb.Message.getBooleanFieldWithDefault(msg, 407, false),
enableBatteryFrettingAlerts: jspb.Message.getBooleanFieldWithDefault(msg, 409, false),
includeCaseIdsInAxonEvidenceTitle: jspb.Message.getBooleanFieldWithDefault(msg, 411, false),
showInternalFlightDeckCommands: jspb.Message.getBooleanFieldWithDefault(msg, 412, false),
disableEmailLogins: jspb.Message.getBooleanFieldWithDefault(msg, 416, false),
multipleMediaSyncPolicies: jspb.Message.getBooleanFieldWithDefault(msg, 420, false),
showA22DetailsInUi: jspb.Message.getBooleanFieldWithDefault(msg, 422, false),
subjectTracking: jspb.Message.getBooleanFieldWithDefault(msg, 424, false),
assetInspectionMissionPlanningV0: jspb.Message.getBooleanFieldWithDefault(msg, 425, false),
enablePreFlightChecklists: jspb.Message.getBooleanFieldWithDefault(msg, 426, false),
brandingDfrCommand: jspb.Message.getBooleanFieldWithDefault(msg, 427, false),
enableSurfaceScanSkillTeleop: jspb.Message.getBooleanFieldWithDefault(msg, 429, false),
autonomyWidgetRfd: jspb.Message.getBooleanFieldWithDefault(msg, 430, false),
showPropellerHoursTrackingOverrideSetting: jspb.Message.getBooleanFieldWithDefault(msg, 431, false),
dockComputeReplacement: jspb.Message.getBooleanFieldWithDefault(msg, 432, false),
allowScanPlaneOffsetForMapCapture: jspb.Message.getBooleanFieldWithDefault(msg, 435, false),
rtkPpkRfdTelemetry: jspb.Message.getBooleanFieldWithDefault(msg, 436, false),
subjectTrackingForEngineering: jspb.Message.getBooleanFieldWithDefault(msg, 437, false),
enableMultidroneAscendFy26: jspb.Message.getBooleanFieldWithDefault(msg, 440, false),
cloudSimRecreateExperience: jspb.Message.getBooleanFieldWithDefault(msg, 444, false),
onpremManagementOrganization: jspb.Message.getBooleanFieldWithDefault(msg, 446, false),
showAdaptiveCaptureSettingsUi: jspb.Message.getBooleanFieldWithDefault(msg, 448, false),
enableFlightSystemRebootScheduler: jspb.Message.getBooleanFieldWithDefault(msg, 449, false),
enableCloudSimTailscale: jspb.Message.getBooleanFieldWithDefault(msg, 450, false),
getPermissionFromSimTeamFirstEnableR71CloudSimulator: jspb.Message.getBooleanFieldWithDefault(msg, 451, false),
editOrgCaptureSettingsNondocked: jspb.Message.getBooleanFieldWithDefault(msg, 452, false),
renderBackendScanPlan: jspb.Message.getBooleanFieldWithDefault(msg, 453, false),
enableCloudDrivenEncryption: jspb.Message.getBooleanFieldWithDefault(msg, 454, false),
missionDeviceSwitching: jspb.Message.getBooleanFieldWithDefault(msg, 455, false),
assetSettingsView: jspb.Message.getBooleanFieldWithDefault(msg, 456, false),
cloudSimShow2025AscendVersions: jspb.Message.getBooleanFieldWithDefault(msg, 457, false),
missionSettingsFlightPolicyV0: jspb.Message.getBooleanFieldWithDefault(msg, 458, false),
apiPortalDownloadParity: jspb.Message.getBooleanFieldWithDefault(msg, 459, false),
geofenceAwareMissionPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 460, false),
inmAscendFy26: jspb.Message.getBooleanFieldWithDefault(msg, 461, false),
applyC18IrqStormCloudOverridesToOrg: jspb.Message.getBooleanFieldWithDefault(msg, 462, false),
aglFromVehicleRfd: jspb.Message.getBooleanFieldWithDefault(msg, 463, false),
stopSendingAutoRecordTrueFromRfd: jspb.Message.getBooleanFieldWithDefault(msg, 464, false),
useDeviceSoftwareCompatibilityMatrix: jspb.Message.getBooleanFieldWithDefault(msg, 465, false),
rfdEarlyPrep: jspb.Message.getBooleanFieldWithDefault(msg, 466, false),
rfdPathfinderDisablesNightsense: jspb.Message.getBooleanFieldWithDefault(msg, 467, false),
axonAlprIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 468, false),
enableComputeMissionTrajectory: jspb.Message.getBooleanFieldWithDefault(msg, 469, false),
enable1hzDispatchTelemetryDownsampling: jspb.Message.getBooleanFieldWithDefault(msg, 470, false),
showBitratePresetInFlightPolicy: jspb.Message.getBooleanFieldWithDefault(msg, 471, false),
hideSafeLandingIfNoneSet: jspb.Message.getBooleanFieldWithDefault(msg, 472, false),
missionEditorHeightFrameSelector: jspb.Message.getBooleanFieldWithDefault(msg, 474, false),
fususCadIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 475, false),
enableAlertText: jspb.Message.getBooleanFieldWithDefault(msg, 476, false),
mpegTsSettings: jspb.Message.getBooleanFieldWithDefault(msg, 477, false),
exposeOrgTier: jspb.Message.getBooleanFieldWithDefault(msg, 478, false),
undoUpsertMarkerOptimization: jspb.Message.getBooleanFieldWithDefault(msg, 480, false),
nomadMapsMissionEditor: jspb.Message.getBooleanFieldWithDefault(msg, 481, false),
unifiedPostMissionActions: jspb.Message.getBooleanFieldWithDefault(msg, 482, false),
hardwareKeyEncryptionEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 484, false),
writeAddressForBodycams: jspb.Message.getBooleanFieldWithDefault(msg, 485, false),
dedroneIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 486, false),
enableVideoFeedbackSurvey: jspb.Message.getBooleanFieldWithDefault(msg, 487, false),
paraverseArcadePostFlightForm: jspb.Message.getBooleanFieldWithDefault(msg, 488, false),
enableMultidroneRfd: jspb.Message.getBooleanFieldWithDefault(msg, 489, false),
allowDocklessLiveMissionPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 490, false),
arSyncInWorker: jspb.Message.getBooleanFieldWithDefault(msg, 491, false),
rfdEnableDroneDockName: jspb.Message.getBooleanFieldWithDefault(msg, 492, false),
hiveAcs: jspb.Message.getBooleanFieldWithDefault(msg, 493, false),
controllerSupportCloudEncryption: jspb.Message.getBooleanFieldWithDefault(msg, 494, false),
extendGeofenceVertexLimit: jspb.Message.getBooleanFieldWithDefault(msg, 495, false),
skillsSelectorInAutonomyWidget: jspb.Message.getBooleanFieldWithDefault(msg, 496, false),
reactPerfFixes: jspb.Message.getBooleanFieldWithDefault(msg, 497, false),
pathfinderBoundariesMenu: jspb.Message.getBooleanFieldWithDefault(msg, 499, false),
rfdHigherMaxSpeed: jspb.Message.getBooleanFieldWithDefault(msg, 500, false),
cadIdSyncing: jspb.Message.getBooleanFieldWithDefault(msg, 501, false),
clearMarkersDispatchMap: jspb.Message.getBooleanFieldWithDefault(msg, 502, false),
rfdPrimaryAltitudeSetting: jspb.Message.getBooleanFieldWithDefault(msg, 504, false),
gen2G47ChargerEap: jspb.Message.getBooleanFieldWithDefault(msg, 507, false),
enableSentryAutodetection: jspb.Message.getBooleanFieldWithDefault(msg, 508, false),
fixLivestreamMutation: jspb.Message.getBooleanFieldWithDefault(msg, 509, false),
markersBackendFiltering: jspb.Message.getBooleanFieldWithDefault(msg, 511, false),
suppressAirTrafficAlertsWhenGrounded: jspb.Message.getBooleanFieldWithDefault(msg, 512, false),
rfdOnSubdomain: jspb.Message.getBooleanFieldWithDefault(msg, 513, false),
fleetMapViewEnhancements: jspb.Message.getBooleanFieldWithDefault(msg, 514, false),
consumablesUsageAlerts: jspb.Message.getBooleanFieldWithDefault(msg, 1812, false),
singleClickOtaExtended: jspb.Message.getBooleanFieldWithDefault(msg, 9001, false),
cloudRel13UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 518, false),
atlasPointsRfdV2: jspb.Message.getBooleanFieldWithDefault(msg, 520, false),
missionsInRfdV2: jspb.Message.getBooleanFieldWithDefault(msg, 521, false),
missionResumability: jspb.Message.getBooleanFieldWithDefault(msg, 522, false),
playwrightBlankMapRendering: jspb.Message.getBooleanFieldWithDefault(msg, 523, false),
cloudRelCayleyUiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 524, false),
enableRfdv2SidebarLayout: jspb.Message.getBooleanFieldWithDefault(msg, 525, false),
enablePathfinderBoundaryManagement: jspb.Message.getBooleanFieldWithDefault(msg, 526, false),
showDeviceFactoryResetUi: jspb.Message.getBooleanFieldWithDefault(msg, 527, false),
showProductImprovementConsentToggle: jspb.Message.getBooleanFieldWithDefault(msg, 528, false),
enableParaverseArcadeCreation: jspb.Message.getBooleanFieldWithDefault(msg, 529, false),
nomadTrueOrthographicMode: jspb.Message.getBooleanFieldWithDefault(msg, 530, false),
contentHintMotion: jspb.Message.getBooleanFieldWithDefault(msg, 532, false),
manageAdsbAlertSettingsWithOrgOverride: jspb.Message.getBooleanFieldWithDefault(msg, 533, false),
enableAglGeofences: jspb.Message.getBooleanFieldWithDefault(msg, 534, false),
enableRfdv2SidebarStack: jspb.Message.getBooleanFieldWithDefault(msg, 535, false),
fetchRecordingBodycamsOnly: jspb.Message.getBooleanFieldWithDefault(msg, 536, false),
zeroLatencyControls: jspb.Message.getBooleanFieldWithDefault(msg, 537, false),
enableViewerCountFromRedis: jspb.Message.getBooleanFieldWithDefault(msg, 538, false),
atlasPointsRfdV2MarkersOnly: jspb.Message.getBooleanFieldWithDefault(msg, 539, false),
rfdOnSubdomainForEngineering: jspb.Message.getBooleanFieldWithDefault(msg, 540, false),
gamepadSubjectTracking: jspb.Message.getBooleanFieldWithDefault(msg, 541, false),
filterByHealthStatus: jspb.Message.getBooleanFieldWithDefault(msg, 542, false),
flatListOfHealthIssues: jspb.Message.getBooleanFieldWithDefault(msg, 543, false),
integrateKmlImporterIntoMissionPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 544, false),
shotspotterIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 546, false),
enableRfdV2ComingSoonBanner: jspb.Message.getBooleanFieldWithDefault(msg, 547, false),
enableFileAutoRetentionAndSoftDelete: jspb.Message.getBooleanFieldWithDefault(msg, 548, false),
splitUserMediaUploadProgress: jspb.Message.getBooleanFieldWithDefault(msg, 549, false),
enableCloudTakMarkers: jspb.Message.getBooleanFieldWithDefault(msg, 550, false),
flightSystemViewRedesign: jspb.Message.getBooleanFieldWithDefault(msg, 551, false),
sitesGeofenceImportExport: jspb.Message.getBooleanFieldWithDefault(msg, 552, false),
enableMarkersGqlFederation: jspb.Message.getBooleanFieldWithDefault(msg, 553, false),
assetSurveyFromPhotos: jspb.Message.getBooleanFieldWithDefault(msg, 554, false),
flightDetailsPage: jspb.Message.getBooleanFieldWithDefault(msg, 555, false),
debounceLiveStreamAlert: jspb.Message.getBooleanFieldWithDefault(msg, 556, false),
enableRticMode: jspb.Message.getBooleanFieldWithDefault(msg, 557, false),
enableDeclarativeDockview: jspb.Message.getBooleanFieldWithDefault(msg, 558, false),
enableCustomRfdUrl: jspb.Message.getBooleanFieldWithDefault(msg, 559, false),
enableFlightPathVisualization: jspb.Message.getBooleanFieldWithDefault(msg, 560, false),
enableViewSalesforceSupportCases: jspb.Message.getBooleanFieldWithDefault(msg, 561, false),
consumablesReport: jspb.Message.getBooleanFieldWithDefault(msg, 562, false),
fasterTtl: jspb.Message.getBooleanFieldWithDefault(msg, 563, false),
enablePlannedOperations: jspb.Message.getBooleanFieldWithDefault(msg, 564, false),
enableDockedRthDeconfliction: jspb.Message.getBooleanFieldWithDefault(msg, 565, false),
enableHistoricalMarkerFilters: jspb.Message.getBooleanFieldWithDefault(msg, 566, false),
enableOperationsV0: jspb.Message.getBooleanFieldWithDefault(msg, 567, false),
missionRunning: jspb.Message.getBooleanFieldWithDefault(msg, 568, false),
showFileAutoDeletionUx: jspb.Message.getBooleanFieldWithDefault(msg, 569, false),
integrationUiImprovements: jspb.Message.getBooleanFieldWithDefault(msg, 570, false),
betterSupportLogUpload: jspb.Message.getBooleanFieldWithDefault(msg, 571, false),
frontendBeta: jspb.Message.getBooleanFieldWithDefault(msg, 572, false),
showLastPilotFlown: jspb.Message.getBooleanFieldWithDefault(msg, 573, false),
displayThemeSettingsView: jspb.Message.getBooleanFieldWithDefault(msg, 574, false),
pilotDetailPage: jspb.Message.getBooleanFieldWithDefault(msg, 575, false),
enableNorthIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 576, false),
healthStatusChangedAlert: jspb.Message.getBooleanFieldWithDefault(msg, 577, false),
rfdCollapsibleSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 579, false),
rfdPinnableSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 580, false),
enableAglHeightCeiling: jspb.Message.getBooleanFieldWithDefault(msg, 578, false),
displayPathfinderBoundariesInMaps: jspb.Message.getBooleanFieldWithDefault(msg, 581, false),
orgRegionTransfer: jspb.Message.getBooleanFieldWithDefault(msg, 582, false),
showParachuteRequiredSetting: jspb.Message.getBooleanFieldWithDefault(msg, 583, false),
cloudRtkProfiles: jspb.Message.getBooleanFieldWithDefault(msg, 584, false),
rfdCockpitV2: jspb.Message.getBooleanFieldWithDefault(msg, 585, false),
showAuditEvents: jspb.Message.getBooleanFieldWithDefault(msg, 586, false),
overrideMotionApiToLegacy: jspb.Message.getBooleanFieldWithDefault(msg, 587, false),
rfd3dCockpit: jspb.Message.getBooleanFieldWithDefault(msg, 588, false),
pilotLeaderboard: jspb.Message.getBooleanFieldWithDefault(msg, 589, false),
customMapLayersFromCloud: jspb.Message.getBooleanFieldWithDefault(msg, 590, false),
enableAglWaypointAltitudesRfd: jspb.Message.getBooleanFieldWithDefault(msg, 591, false),
completeStacknavSidebar: jspb.Message.getBooleanFieldWithDefault(msg, 592, false),
enableMulticockpitRfd: jspb.Message.getBooleanFieldWithDefault(msg, 593, false),
takIntegration: jspb.Message.getBooleanFieldWithDefault(msg, 594, false),
enableTogglingGeofencesRfd: jspb.Message.getBooleanFieldWithDefault(msg, 595, false),
reliableCommandeering: jspb.Message.getBooleanFieldWithDefault(msg, 596, false),
enableMarkerFilterSettings: jspb.Message.getBooleanFieldWithDefault(msg, 597, false),
rfdLaunchWhenReady: jspb.Message.getBooleanFieldWithDefault(msg, 598, false),
enableCloudNtrip: jspb.Message.getBooleanFieldWithDefault(msg, 599, false),
enableAcademyOnlineCode: jspb.Message.getBooleanFieldWithDefault(msg, 600, false),
evidenceViaGo: jspb.Message.getBooleanFieldWithDefault(msg, 601, false),
enableMultidroneAdsbRfd: jspb.Message.getBooleanFieldWithDefault(msg, 602, false),
warningEnforcementMode: jspb.Message.getBooleanFieldWithDefault(msg, 603, false),
waypointDragReorder: jspb.Message.getBooleanFieldWithDefault(msg, 604, false),
aiAgentRfd: jspb.Message.getBooleanFieldWithDefault(msg, 605, false),
cloudRel14UiUpdates: jspb.Message.getBooleanFieldWithDefault(msg, 606, false),
useAdsbRegulatoryManagerInfo: jspb.Message.getBooleanFieldWithDefault(msg, 607, false),
enableAdsbRegulatoryManagerSettings: jspb.Message.getBooleanFieldWithDefault(msg, 608, false),
editOrgFlightPolicyR10: jspb.Message.getBooleanFieldWithDefault(msg, 609, false),
offlinePortal: jspb.Message.getBooleanFieldWithDefault(msg, 610, false),
rfdDisableDataThrottle: jspb.Message.getBooleanFieldWithDefault(msg, 611, false),
tapToFocusRfd: jspb.Message.getBooleanFieldWithDefault(msg, 612, false),
automaticVexcelDsmIngest: jspb.Message.getBooleanFieldWithDefault(msg, 613, false),
enableMultiDroneRid: jspb.Message.getBooleanFieldWithDefault(msg, 614, false),
part107Certification: jspb.Message.getBooleanFieldWithDefault(msg, 615, false),
enableInlineMarkerEditing: jspb.Message.getBooleanFieldWithDefault(msg, 616, false),
transparencyDashboardV2: jspb.Message.getBooleanFieldWithDefault(msg, 617, false),
enableOutOfService: jspb.Message.getBooleanFieldWithDefault(msg, 618, false),
tagSettingsView: jspb.Message.getBooleanFieldWithDefault(msg, 619, false),
missionEditorNomadMapDevSwitch: jspb.Message.getBooleanFieldWithDefault(msg, 620, false),
cloudRtkProfileApiKeySupport: jspb.Message.getBooleanFieldWithDefault(msg, 621, false),
enablePeriodicBkScan: jspb.Message.getBooleanFieldWithDefault(msg, 622, false),
runAxonPollerOnSkypoller: jspb.Message.getBooleanFieldWithDefault(msg, 623, false),
enableGlobalAirspaceDeconfliction: jspb.Message.getBooleanFieldWithDefault(msg, 624, false),
showSsoJitToggle: jspb.Message.getBooleanFieldWithDefault(msg, 625, false),
showAfRegionRfd: jspb.Message.getBooleanFieldWithDefault(msg, 626, false),
consumablesV2Panel: jspb.Message.getBooleanFieldWithDefault(msg, 627, false),
useFoundryClient: jspb.Message.getBooleanFieldWithDefault(msg, 628, false),
enablePowerLineGeofences: jspb.Message.getBooleanFieldWithDefault(msg, 629, false),
enableGeoLookat: jspb.Message.getBooleanFieldWithDefault(msg, 630, false),
setupScheduledFlightsFromCloud: jspb.Message.getBooleanFieldWithDefault(msg, 631, false),
showH265Toggle: jspb.Message.getBooleanFieldWithDefault(msg, 632, false),
rfdEnableControllerCustomization: jspb.Message.getBooleanFieldWithDefault(msg, 633, false),
rgScopedIntegrations: jspb.Message.getBooleanFieldWithDefault(msg, 634, false),
fusionPlusOta: jspb.Message.getBooleanFieldWithDefault(msg, 635, false),
enableDockCirclesLayer: jspb.Message.getBooleanFieldWithDefault(msg, 636, false),
rfdEnableRthOptimalSlider: jspb.Message.getBooleanFieldWithDefault(msg, 637, false),
preReleaseFeatureControls: jspb.Message.getBooleanFieldWithDefault(msg, 638, false),
enableManualClipCapture: jspb.Message.getBooleanFieldWithDefault(msg, 639, false),
enableWeatherInference: jspb.Message.getBooleanFieldWithDefault(msg, 640, false),
enableDroneInspectionTracking: jspb.Message.getBooleanFieldWithDefault(msg, 641, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.FeatureFlags}
 */
proto.cloud_api.FeatureFlags.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.FeatureFlags;
  return proto.cloud_api.FeatureFlags.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.FeatureFlags} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.FeatureFlags}
 */
proto.cloud_api.FeatureFlags.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleTeleoperation(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticFileUploadPage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLiveStreaming(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonMediaIntegration(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionsPage(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonRespondIntegration(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setViewOfflineSettings(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConfigureObstacleMargin(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDroInternal(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnnotations(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudInspectPage(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionMediaViewer(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticCloudPhotogrammetry(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDockLocationUpdate(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableTeleopLandingPrompt(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDroTeleopRunMissionJson(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideLandNowDuringRtd(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoteVideoApiAccess(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowTwilightFlight(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowBacktrackingRtx(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudOta(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopDebugMenu(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQosSkybusChannelSetting(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPostRefactorMissionEditor(value);
      break;
    case 46:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNetworkDebuggingTools(value);
      break;
    case 47:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullHeightVideoEnabled(value);
      break;
    case 49:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNavHeightAboveGroundEnabled(value);
      break;
    case 51:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternalThemeToggle(value);
      break;
    case 53:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomerCustomMapboxMapStyles(value);
      break;
    case 63:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowVehicleFaultsTeleop(value);
      break;
    case 66:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowVpsInfo(value);
      break;
    case 67:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopArV2(value);
      break;
    case 68:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionControlApi(value);
      break;
    case 71:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSurfaceScanMissions(value);
      break;
    case 72:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAprilTagSettings(value);
      break;
    case 80:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowRangeLimitSettings(value);
      break;
    case 85:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSiteMapper(value);
      break;
    case 86:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowBandSelectionSettings(value);
      break;
    case 87:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlyNowNoAutomaticRunModeSwitching(value);
      break;
    case 88:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArVideoSync(value);
      break;
    case 89:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionResults3dViewer(value);
      break;
    case 92:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticNcpgPhotogrammetry(value);
      break;
    case 93:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExecutiveActionHotkeys(value);
      break;
    case 94:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVehicleTypeBasedAxonSessions(value);
      break;
    case 99:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlwaysShowCameraSettings(value);
      break;
    case 101:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopWaypointCommands(value);
      break;
    case 108:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPropGuardsEnablement(value);
      break;
    case 111:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemotePilotApiAccess(value);
      break;
    case 112:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowViewFlightDeckButton(value);
      break;
    case 113:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTwilightModeFastFlight(value);
      break;
    case 114:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStandaloneMapPage(value);
      break;
    case 116:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLostCommsTimeoutSettingTeleop(value);
      break;
    case 117:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopFastFlight(value);
      break;
    case 119:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowEditAdsbSettings(value);
      break;
    case 121:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTeleopIdleModal(value);
      break;
    case 122:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkydioExtend(value);
      break;
    case 123:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportMenuV2(value);
      break;
    case 125:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceEnforcementInCloud(value);
      break;
    case 129:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopThirdPersonView(value);
      break;
    case 132:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTeleopCircularBatteryWidget(value);
      break;
    case 134:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStructureAnnotationsApi(value);
      break;
    case 138:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnOrgGroups(value);
      break;
    case 139:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopCommandeeringV2(value);
      break;
    case 142:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNcpgPhotogrammetryUseTensorRtFlowModel(value);
      break;
    case 143:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowFaaMapboxStyles(value);
      break;
    case 147:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSitesStructureEditor(value);
      break;
    case 148:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiMissionFlightTester(value);
      break;
    case 154:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setX10EoCameraControlsParityInTeleop(value);
      break;
    case 155:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoObstacleAvoidanceInTeleop(value);
      break;
    case 162:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVpsMapDatamodelTransitionReadFromNew(value);
      break;
    case 163:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVpsMapDatamodelTransitionWriteToBoth(value);
      break;
    case 164:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgFlightPolicy(value);
      break;
    case 165:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopWheelZoom(value);
      break;
    case 166:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultizoneSiteGeofences(value);
      break;
    case 168:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopBitrateSlider(value);
      break;
    case 171:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRidFeatureDisabled(value);
      break;
    case 174:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSafeLandingPoints(value);
      break;
    case 177:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopBoostMode(value);
      break;
    case 178:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopCrawlMode(value);
      break;
    case 180:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOperationsAreaMapboxStyles(value);
      break;
    case 183:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBarometerHeightMode(value);
      break;
    case 186:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGraphiqlViewer(value);
      break;
    case 187:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOrbitToPoiRfd(value);
      break;
    case 188:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableCloudConfigSignatureVerification(value);
      break;
    case 189:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOnpremOrg(value);
      break;
    case 192:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMapVehicleFollowiing(value);
      break;
    case 194:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopTelemetryHeadingAndGimbalPitch(value);
      break;
    case 195:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaPageKindDropdown(value);
      break;
    case 196:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopActionsToolbar(value);
      break;
    case 199:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockLandingAr(value);
      break;
    case 201:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopNavSourceInfoHealth(value);
      break;
    case 202:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAxonMarkersRfd(value);
      break;
    case 203:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFpvOnMap(value);
      break;
    case 206:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGimbalPitchResetShortcut(value);
      break;
    case 208:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setR47ShowMissionPlanners(value);
      break;
    case 209:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdControllerMaxSpeedParity(value);
      break;
    case 210:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableArStreetOverlays(value);
      break;
    case 213:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdHudCompass(value);
      break;
    case 216:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdHudAirspeedAltitude(value);
      break;
    case 220:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMoveVehicleLaunchModalVideoFeed(value);
      break;
    case 222:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockTransitPoint(value);
      break;
    case 227:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsePathfinderFlyToPointRfd(value);
      break;
    case 228:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaAvailableForFlightAlert(value);
      break;
    case 232:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDfrStockSettings(value);
      break;
    case 234:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomer2CustomMapboxMapStyles(value);
      break;
    case 236:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdConnectivitySettingsTab(value);
      break;
    case 237:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorNightAutonomy(value);
      break;
    case 238:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdParachuteAttachmentUi(value);
      break;
    case 239:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowCloudSimulatorControls(value);
      break;
    case 240:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionSharingCustomerPortal(value);
      break;
    case 243:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseImprovedFlightStatusWorkflow(value);
      break;
    case 247:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdTelemetryStats(value);
      break;
    case 248:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOperationsAreaInternalMapboxStyles(value);
      break;
    case 249:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActivateStrobeLightsOnLaunchRfd(value);
      break;
    case 250:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionDocumentsApi(value);
      break;
    case 251:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFleetPageSdCardFormatting(value);
      break;
    case 252:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneOperations(value);
      break;
    case 254:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setControlKeyDragWaypointVertical(value);
      break;
    case 255:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTerrainAndBldgsToggleInFleetPage(value);
      break;
    case 259:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowOverlappingDockWifiChannelsFleetPage(value);
      break;
    case 261:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInternalMapboxStyles3(value);
      break;
    case 262:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFixedLocationRid(value);
      break;
    case 264:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTeleopPilotKeepAlive(value);
      break;
    case 272:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRtkSupport(value);
      break;
    case 274:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCityCustomerMapboxMapStyles(value);
      break;
    case 276:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinkLossAlertLevelCaution(value);
      break;
    case 288:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSetupFlights(value);
      break;
    case 289:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEuropeanUnion(value);
      break;
    case 292:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCreateMarkerInteractionRfd(value);
      break;
    case 293:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDronesenseIntegrationSetup(value);
      break;
    case 295:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableC18MicrohardOfflineConfiguration(value);
      break;
    case 296:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomMapLayersExternal(value);
      break;
    case 297:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomMapLayersInternal(value);
      break;
    case 303:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterMarkersInRfdSidebar(value);
      break;
    case 305:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDfrCommand(value);
      break;
    case 306:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionDetailsAboveSkillsSwitcher(value);
      break;
    case 307:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiBatteryMissions(value);
      break;
    case 308:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSwapToX10DockCamOnLanding(value);
      break;
    case 310:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdDedrone(value);
      break;
    case 311:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdAdsbRecording(value);
      break;
    case 313:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorShowInternalNavigationModeOptions(value);
      break;
    case 314:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseTwoUi(value);
      break;
    case 315:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseTwoPointFiveUi(value);
      break;
    case 316:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrCommandPhaseThreeUi(value);
      break;
    case 317:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrOrgBasedLivekitRoom(value);
      break;
    case 318:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setX10DefaultsForGpsInitWaypoint(value);
      break;
    case 324:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableProperArSync(value);
      break;
    case 329:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdViewLookatPoint(value);
      break;
    case 330:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdSetLookatPoint(value);
      break;
    case 333:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSimulateRemoteOnPremOrg(value);
      break;
    case 337:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultiOrgUsersRpic(value);
      break;
    case 339:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkersApi(value);
      break;
    case 342:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDirectDeviceAdoption(value);
      break;
    case 343:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDocklessSites(value);
      break;
    case 347:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTeleopInIframe(value);
      break;
    case 348:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrDockviewLayout(value);
      break;
    case 349:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomerManagedSessionLengths(value);
      break;
    case 352:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDispatchRespondHere(value);
      break;
    case 355:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeploymentEngineerMissionsInternal(value);
      break;
    case 357:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetTakePhotoWaitForFocusToConverge(value);
      break;
    case 360:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableValidationOfOnDemandMission(value);
      break;
    case 361:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAxonWatchMeDemo(value);
      break;
    case 363:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableIncidentsStateUi(value);
      break;
    case 364:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePlanningAroundGeofencesFlyToPointRfd(value);
      break;
    case 368:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHiveChannelConflictPrevention(value);
      break;
    case 370:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnifiedMissionEditor(value);
      break;
    case 371:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionsCloudToController(value);
      break;
    case 372:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableWaypointMetricsWorkflow(value);
      break;
    case 373:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePropellerTypeSpecification(value);
      break;
    case 374:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setImprovedLandingButtons(value);
      break;
    case 376:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCancelIncidentResponseModal(value);
      break;
    case 378:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayCellularCarrierInfo(value);
      break;
    case 379:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableUnsupportedBrowserWarning(value);
      break;
    case 380:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableExtraAccessModes(value);
      break;
    case 381:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomMapLayersBackend(value);
      break;
    case 383:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverseGeocodeMarkersOnRead(value);
      break;
    case 385:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgFlightPolicyNondocked(value);
      break;
    case 387:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSitesImprovements525(value);
      break;
    case 388:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel5UiUpdates(value);
      break;
    case 389:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowFileReleaseUi(value);
      break;
    case 390:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseX10rev1AndUnknownAcceleratedPropWearAlert(value);
      break;
    case 391:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseX10rev2AcceleratedPropWearAlert(value);
      break;
    case 392:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRtkEarlyAccessProgram(value);
      break;
    case 393:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewCloudNavigation(value);
      break;
    case 394:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApiObservability(value);
      break;
    case 395:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewIntegrationsUi(value);
      break;
    case 397:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdatedCreateOrganizationModal(value);
      break;
    case 398:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudSimAutomaticSiteSetup(value);
      break;
    case 402:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePostFlightReports(value);
      break;
    case 406:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDfrOutcomesSurvey(value);
      break;
    case 407:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdStreamlineNotifications(value);
      break;
    case 409:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBatteryFrettingAlerts(value);
      break;
    case 411:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCaseIdsInAxonEvidenceTitle(value);
      break;
    case 412:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInternalFlightDeckCommands(value);
      break;
    case 416:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableEmailLogins(value);
      break;
    case 420:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMultipleMediaSyncPolicies(value);
      break;
    case 422:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowA22DetailsInUi(value);
      break;
    case 424:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubjectTracking(value);
      break;
    case 425:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAssetInspectionMissionPlanningV0(value);
      break;
    case 426:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePreFlightChecklists(value);
      break;
    case 427:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrandingDfrCommand(value);
      break;
    case 429:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSurfaceScanSkillTeleop(value);
      break;
    case 430:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutonomyWidgetRfd(value);
      break;
    case 431:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowPropellerHoursTrackingOverrideSetting(value);
      break;
    case 432:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDockComputeReplacement(value);
      break;
    case 435:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowScanPlaneOffsetForMapCapture(value);
      break;
    case 436:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRtkPpkRfdTelemetry(value);
      break;
    case 437:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubjectTrackingForEngineering(value);
      break;
    case 440:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneAscendFy26(value);
      break;
    case 444:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudSimRecreateExperience(value);
      break;
    case 446:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnpremManagementOrganization(value);
      break;
    case 448:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAdaptiveCaptureSettingsUi(value);
      break;
    case 449:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFlightSystemRebootScheduler(value);
      break;
    case 450:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudSimTailscale(value);
      break;
    case 451:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGetPermissionFromSimTeamFirstEnableR71CloudSimulator(value);
      break;
    case 452:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgCaptureSettingsNondocked(value);
      break;
    case 453:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRenderBackendScanPlan(value);
      break;
    case 454:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudDrivenEncryption(value);
      break;
    case 455:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionDeviceSwitching(value);
      break;
    case 456:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAssetSettingsView(value);
      break;
    case 457:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudSimShow2025AscendVersions(value);
      break;
    case 458:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionSettingsFlightPolicyV0(value);
      break;
    case 459:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApiPortalDownloadParity(value);
      break;
    case 460:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGeofenceAwareMissionPlanning(value);
      break;
    case 461:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInmAscendFy26(value);
      break;
    case 462:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplyC18IrqStormCloudOverridesToOrg(value);
      break;
    case 463:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAglFromVehicleRfd(value);
      break;
    case 464:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStopSendingAutoRecordTrueFromRfd(value);
      break;
    case 465:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseDeviceSoftwareCompatibilityMatrix(value);
      break;
    case 466:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdEarlyPrep(value);
      break;
    case 467:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdPathfinderDisablesNightsense(value);
      break;
    case 468:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAxonAlprIntegration(value);
      break;
    case 469:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableComputeMissionTrajectory(value);
      break;
    case 470:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable1hzDispatchTelemetryDownsampling(value);
      break;
    case 471:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowBitratePresetInFlightPolicy(value);
      break;
    case 472:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideSafeLandingIfNoneSet(value);
      break;
    case 474:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorHeightFrameSelector(value);
      break;
    case 475:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFususCadIntegration(value);
      break;
    case 476:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAlertText(value);
      break;
    case 477:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMpegTsSettings(value);
      break;
    case 478:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExposeOrgTier(value);
      break;
    case 480:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUndoUpsertMarkerOptimization(value);
      break;
    case 481:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNomadMapsMissionEditor(value);
      break;
    case 482:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnifiedPostMissionActions(value);
      break;
    case 484:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHardwareKeyEncryptionEnabled(value);
      break;
    case 485:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWriteAddressForBodycams(value);
      break;
    case 486:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDedroneIntegration(value);
      break;
    case 487:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableVideoFeedbackSurvey(value);
      break;
    case 488:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setParaverseArcadePostFlightForm(value);
      break;
    case 489:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneRfd(value);
      break;
    case 490:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowDocklessLiveMissionPlanning(value);
      break;
    case 491:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArSyncInWorker(value);
      break;
    case 492:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdEnableDroneDockName(value);
      break;
    case 493:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHiveAcs(value);
      break;
    case 494:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setControllerSupportCloudEncryption(value);
      break;
    case 495:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExtendGeofenceVertexLimit(value);
      break;
    case 496:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkillsSelectorInAutonomyWidget(value);
      break;
    case 497:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReactPerfFixes(value);
      break;
    case 499:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPathfinderBoundariesMenu(value);
      break;
    case 500:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdHigherMaxSpeed(value);
      break;
    case 501:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCadIdSyncing(value);
      break;
    case 502:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClearMarkersDispatchMap(value);
      break;
    case 504:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdPrimaryAltitudeSetting(value);
      break;
    case 507:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGen2G47ChargerEap(value);
      break;
    case 508:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSentryAutodetection(value);
      break;
    case 509:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFixLivestreamMutation(value);
      break;
    case 511:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkersBackendFiltering(value);
      break;
    case 512:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuppressAirTrafficAlertsWhenGrounded(value);
      break;
    case 513:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdOnSubdomain(value);
      break;
    case 514:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFleetMapViewEnhancements(value);
      break;
    case 1812:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsumablesUsageAlerts(value);
      break;
    case 9001:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSingleClickOtaExtended(value);
      break;
    case 518:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel13UiUpdates(value);
      break;
    case 520:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAtlasPointsRfdV2(value);
      break;
    case 521:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionsInRfdV2(value);
      break;
    case 522:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionResumability(value);
      break;
    case 523:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlaywrightBlankMapRendering(value);
      break;
    case 524:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRelCayleyUiUpdates(value);
      break;
    case 525:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdv2SidebarLayout(value);
      break;
    case 526:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePathfinderBoundaryManagement(value);
      break;
    case 527:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowDeviceFactoryResetUi(value);
      break;
    case 528:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowProductImprovementConsentToggle(value);
      break;
    case 529:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableParaverseArcadeCreation(value);
      break;
    case 530:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNomadTrueOrthographicMode(value);
      break;
    case 532:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContentHintMotion(value);
      break;
    case 533:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManageAdsbAlertSettingsWithOrgOverride(value);
      break;
    case 534:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAglGeofences(value);
      break;
    case 535:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdv2SidebarStack(value);
      break;
    case 536:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFetchRecordingBodycamsOnly(value);
      break;
    case 537:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setZeroLatencyControls(value);
      break;
    case 538:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableViewerCountFromRedis(value);
      break;
    case 539:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAtlasPointsRfdV2MarkersOnly(value);
      break;
    case 540:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdOnSubdomainForEngineering(value);
      break;
    case 541:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGamepadSubjectTracking(value);
      break;
    case 542:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterByHealthStatus(value);
      break;
    case 543:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlatListOfHealthIssues(value);
      break;
    case 544:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIntegrateKmlImporterIntoMissionPlanning(value);
      break;
    case 546:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShotspotterIntegration(value);
      break;
    case 547:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRfdV2ComingSoonBanner(value);
      break;
    case 548:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFileAutoRetentionAndSoftDelete(value);
      break;
    case 549:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSplitUserMediaUploadProgress(value);
      break;
    case 550:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudTakMarkers(value);
      break;
    case 551:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlightSystemViewRedesign(value);
      break;
    case 552:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSitesGeofenceImportExport(value);
      break;
    case 553:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMarkersGqlFederation(value);
      break;
    case 554:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAssetSurveyFromPhotos(value);
      break;
    case 555:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlightDetailsPage(value);
      break;
    case 556:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebounceLiveStreamAlert(value);
      break;
    case 557:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableRticMode(value);
      break;
    case 558:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDeclarativeDockview(value);
      break;
    case 559:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCustomRfdUrl(value);
      break;
    case 560:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableFlightPathVisualization(value);
      break;
    case 561:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableViewSalesforceSupportCases(value);
      break;
    case 562:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsumablesReport(value);
      break;
    case 563:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFasterTtl(value);
      break;
    case 564:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePlannedOperations(value);
      break;
    case 565:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockedRthDeconfliction(value);
      break;
    case 566:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableHistoricalMarkerFilters(value);
      break;
    case 567:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOperationsV0(value);
      break;
    case 568:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionRunning(value);
      break;
    case 569:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowFileAutoDeletionUx(value);
      break;
    case 570:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIntegrationUiImprovements(value);
      break;
    case 571:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBetterSupportLogUpload(value);
      break;
    case 572:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFrontendBeta(value);
      break;
    case 573:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowLastPilotFlown(value);
      break;
    case 574:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayThemeSettingsView(value);
      break;
    case 575:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPilotDetailPage(value);
      break;
    case 576:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableNorthIndicator(value);
      break;
    case 577:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHealthStatusChangedAlert(value);
      break;
    case 579:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdCollapsibleSidebar(value);
      break;
    case 580:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdPinnableSidebar(value);
      break;
    case 578:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAglHeightCeiling(value);
      break;
    case 581:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayPathfinderBoundariesInMaps(value);
      break;
    case 582:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOrgRegionTransfer(value);
      break;
    case 583:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowParachuteRequiredSetting(value);
      break;
    case 584:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRtkProfiles(value);
      break;
    case 585:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdCockpitV2(value);
      break;
    case 586:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAuditEvents(value);
      break;
    case 587:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideMotionApiToLegacy(value);
      break;
    case 588:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfd3dCockpit(value);
      break;
    case 589:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPilotLeaderboard(value);
      break;
    case 590:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomMapLayersFromCloud(value);
      break;
    case 591:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAglWaypointAltitudesRfd(value);
      break;
    case 592:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleteStacknavSidebar(value);
      break;
    case 593:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMulticockpitRfd(value);
      break;
    case 594:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTakIntegration(value);
      break;
    case 595:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTogglingGeofencesRfd(value);
      break;
    case 596:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReliableCommandeering(value);
      break;
    case 597:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMarkerFilterSettings(value);
      break;
    case 598:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdLaunchWhenReady(value);
      break;
    case 599:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableCloudNtrip(value);
      break;
    case 600:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAcademyOnlineCode(value);
      break;
    case 601:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEvidenceViaGo(value);
      break;
    case 602:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultidroneAdsbRfd(value);
      break;
    case 603:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWarningEnforcementMode(value);
      break;
    case 604:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWaypointDragReorder(value);
      break;
    case 605:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAiAgentRfd(value);
      break;
    case 606:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRel14UiUpdates(value);
      break;
    case 607:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseAdsbRegulatoryManagerInfo(value);
      break;
    case 608:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableAdsbRegulatoryManagerSettings(value);
      break;
    case 609:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEditOrgFlightPolicyR10(value);
      break;
    case 610:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflinePortal(value);
      break;
    case 611:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdDisableDataThrottle(value);
      break;
    case 612:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTapToFocusRfd(value);
      break;
    case 613:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutomaticVexcelDsmIngest(value);
      break;
    case 614:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableMultiDroneRid(value);
      break;
    case 615:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPart107Certification(value);
      break;
    case 616:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableInlineMarkerEditing(value);
      break;
    case 617:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTransparencyDashboardV2(value);
      break;
    case 618:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOutOfService(value);
      break;
    case 619:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTagSettingsView(value);
      break;
    case 620:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMissionEditorNomadMapDevSwitch(value);
      break;
    case 621:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCloudRtkProfileApiKeySupport(value);
      break;
    case 622:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePeriodicBkScan(value);
      break;
    case 623:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRunAxonPollerOnSkypoller(value);
      break;
    case 624:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableGlobalAirspaceDeconfliction(value);
      break;
    case 625:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowSsoJitToggle(value);
      break;
    case 626:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowAfRegionRfd(value);
      break;
    case 627:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsumablesV2Panel(value);
      break;
    case 628:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseFoundryClient(value);
      break;
    case 629:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablePowerLineGeofences(value);
      break;
    case 630:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableGeoLookat(value);
      break;
    case 631:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSetupScheduledFlightsFromCloud(value);
      break;
    case 632:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowH265Toggle(value);
      break;
    case 633:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdEnableControllerCustomization(value);
      break;
    case 634:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRgScopedIntegrations(value);
      break;
    case 635:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFusionPlusOta(value);
      break;
    case 636:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDockCirclesLayer(value);
      break;
    case 637:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRfdEnableRthOptimalSlider(value);
      break;
    case 638:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreReleaseFeatureControls(value);
      break;
    case 639:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableManualClipCapture(value);
      break;
    case 640:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableWeatherInference(value);
      break;
    case 641:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableDroneInspectionTracking(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.FeatureFlags.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.FeatureFlags.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.FeatureFlags} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlags.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleTeleoperation();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAutomaticFileUploadPage();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLiveStreaming();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getAxonMediaIntegration();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMissionsPage();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAxonRespondIntegration();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getViewOfflineSettings();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getConfigureObstacleMargin();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getDroInternal();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getAnnotations();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getCloudInspectPage();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getMissionMediaViewer();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getAutomaticCloudPhotogrammetry();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getDockLocationUpdate();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getDisableTeleopLandingPrompt();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getDroTeleopRunMissionJson();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getHideLandNowDuringRtd();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getRemoteVideoApiAccess();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getAllowTwilightFlight();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getAllowBacktrackingRtx();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getCloudOta();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
  f = message.getTeleopDebugMenu();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
  f = message.getQosSkybusChannelSetting();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
  f = message.getPostRefactorMissionEditor();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
  f = message.getNetworkDebuggingTools();
  if (f) {
    writer.writeBool(
      46,
      f
    );
  }
  f = message.getFullHeightVideoEnabled();
  if (f) {
    writer.writeBool(
      47,
      f
    );
  }
  f = message.getNavHeightAboveGroundEnabled();
  if (f) {
    writer.writeBool(
      49,
      f
    );
  }
  f = message.getInternalThemeToggle();
  if (f) {
    writer.writeBool(
      51,
      f
    );
  }
  f = message.getCustomerCustomMapboxMapStyles();
  if (f) {
    writer.writeBool(
      53,
      f
    );
  }
  f = message.getShowVehicleFaultsTeleop();
  if (f) {
    writer.writeBool(
      63,
      f
    );
  }
  f = message.getShowVpsInfo();
  if (f) {
    writer.writeBool(
      66,
      f
    );
  }
  f = message.getTeleopArV2();
  if (f) {
    writer.writeBool(
      67,
      f
    );
  }
  f = message.getMissionControlApi();
  if (f) {
    writer.writeBool(
      68,
      f
    );
  }
  f = message.getSurfaceScanMissions();
  if (f) {
    writer.writeBool(
      71,
      f
    );
  }
  f = message.getShowAprilTagSettings();
  if (f) {
    writer.writeBool(
      72,
      f
    );
  }
  f = message.getShowRangeLimitSettings();
  if (f) {
    writer.writeBool(
      80,
      f
    );
  }
  f = message.getSiteMapper();
  if (f) {
    writer.writeBool(
      85,
      f
    );
  }
  f = message.getShowBandSelectionSettings();
  if (f) {
    writer.writeBool(
      86,
      f
    );
  }
  f = message.getFlyNowNoAutomaticRunModeSwitching();
  if (f) {
    writer.writeBool(
      87,
      f
    );
  }
  f = message.getArVideoSync();
  if (f) {
    writer.writeBool(
      88,
      f
    );
  }
  f = message.getMissionResults3dViewer();
  if (f) {
    writer.writeBool(
      89,
      f
    );
  }
  f = message.getAutomaticNcpgPhotogrammetry();
  if (f) {
    writer.writeBool(
      92,
      f
    );
  }
  f = message.getExecutiveActionHotkeys();
  if (f) {
    writer.writeBool(
      93,
      f
    );
  }
  f = message.getVehicleTypeBasedAxonSessions();
  if (f) {
    writer.writeBool(
      94,
      f
    );
  }
  f = message.getAlwaysShowCameraSettings();
  if (f) {
    writer.writeBool(
      99,
      f
    );
  }
  f = message.getTeleopWaypointCommands();
  if (f) {
    writer.writeBool(
      101,
      f
    );
  }
  f = message.getPropGuardsEnablement();
  if (f) {
    writer.writeBool(
      108,
      f
    );
  }
  f = message.getRemotePilotApiAccess();
  if (f) {
    writer.writeBool(
      111,
      f
    );
  }
  f = message.getShowViewFlightDeckButton();
  if (f) {
    writer.writeBool(
      112,
      f
    );
  }
  f = message.getTwilightModeFastFlight();
  if (f) {
    writer.writeBool(
      113,
      f
    );
  }
  f = message.getStandaloneMapPage();
  if (f) {
    writer.writeBool(
      114,
      f
    );
  }
  f = message.getLostCommsTimeoutSettingTeleop();
  if (f) {
    writer.writeBool(
      116,
      f
    );
  }
  f = message.getTeleopFastFlight();
  if (f) {
    writer.writeBool(
      117,
      f
    );
  }
  f = message.getAllowEditAdsbSettings();
  if (f) {
    writer.writeBool(
      119,
      f
    );
  }
  f = message.getShowTeleopIdleModal();
  if (f) {
    writer.writeBool(
      121,
      f
    );
  }
  f = message.getSkydioExtend();
  if (f) {
    writer.writeBool(
      122,
      f
    );
  }
  f = message.getSupportMenuV2();
  if (f) {
    writer.writeBool(
      123,
      f
    );
  }
  f = message.getGeofenceEnforcementInCloud();
  if (f) {
    writer.writeBool(
      125,
      f
    );
  }
  f = message.getTeleopThirdPersonView();
  if (f) {
    writer.writeBool(
      129,
      f
    );
  }
  f = message.getShowTeleopCircularBatteryWidget();
  if (f) {
    writer.writeBool(
      132,
      f
    );
  }
  f = message.getStructureAnnotationsApi();
  if (f) {
    writer.writeBool(
      134,
      f
    );
  }
  f = message.getOwnOrgGroups();
  if (f) {
    writer.writeBool(
      138,
      f
    );
  }
  f = message.getTeleopCommandeeringV2();
  if (f) {
    writer.writeBool(
      139,
      f
    );
  }
  f = message.getNcpgPhotogrammetryUseTensorRtFlowModel();
  if (f) {
    writer.writeBool(
      142,
      f
    );
  }
  f = message.getShowFaaMapboxStyles();
  if (f) {
    writer.writeBool(
      143,
      f
    );
  }
  f = message.getSitesStructureEditor();
  if (f) {
    writer.writeBool(
      147,
      f
    );
  }
  f = message.getMultiMissionFlightTester();
  if (f) {
    writer.writeBool(
      148,
      f
    );
  }
  f = message.getX10EoCameraControlsParityInTeleop();
  if (f) {
    writer.writeBool(
      154,
      f
    );
  }
  f = message.getNoObstacleAvoidanceInTeleop();
  if (f) {
    writer.writeBool(
      155,
      f
    );
  }
  f = message.getVpsMapDatamodelTransitionReadFromNew();
  if (f) {
    writer.writeBool(
      162,
      f
    );
  }
  f = message.getVpsMapDatamodelTransitionWriteToBoth();
  if (f) {
    writer.writeBool(
      163,
      f
    );
  }
  f = message.getEditOrgFlightPolicy();
  if (f) {
    writer.writeBool(
      164,
      f
    );
  }
  f = message.getTeleopWheelZoom();
  if (f) {
    writer.writeBool(
      165,
      f
    );
  }
  f = message.getMultizoneSiteGeofences();
  if (f) {
    writer.writeBool(
      166,
      f
    );
  }
  f = message.getTeleopBitrateSlider();
  if (f) {
    writer.writeBool(
      168,
      f
    );
  }
  f = message.getRidFeatureDisabled();
  if (f) {
    writer.writeBool(
      171,
      f
    );
  }
  f = message.getSafeLandingPoints();
  if (f) {
    writer.writeBool(
      174,
      f
    );
  }
  f = message.getTeleopBoostMode();
  if (f) {
    writer.writeBool(
      177,
      f
    );
  }
  f = message.getTeleopCrawlMode();
  if (f) {
    writer.writeBool(
      178,
      f
    );
  }
  f = message.getShowOperationsAreaMapboxStyles();
  if (f) {
    writer.writeBool(
      180,
      f
    );
  }
  f = message.getBarometerHeightMode();
  if (f) {
    writer.writeBool(
      183,
      f
    );
  }
  f = message.getGraphiqlViewer();
  if (f) {
    writer.writeBool(
      186,
      f
    );
  }
  f = message.getEnableOrbitToPoiRfd();
  if (f) {
    writer.writeBool(
      187,
      f
    );
  }
  f = message.getDisableCloudConfigSignatureVerification();
  if (f) {
    writer.writeBool(
      188,
      f
    );
  }
  f = message.getIsOnpremOrg();
  if (f) {
    writer.writeBool(
      189,
      f
    );
  }
  f = message.getEnableMapVehicleFollowiing();
  if (f) {
    writer.writeBool(
      192,
      f
    );
  }
  f = message.getTeleopTelemetryHeadingAndGimbalPitch();
  if (f) {
    writer.writeBool(
      194,
      f
    );
  }
  f = message.getMediaPageKindDropdown();
  if (f) {
    writer.writeBool(
      195,
      f
    );
  }
  f = message.getTeleopActionsToolbar();
  if (f) {
    writer.writeBool(
      196,
      f
    );
  }
  f = message.getEnableDockLandingAr();
  if (f) {
    writer.writeBool(
      199,
      f
    );
  }
  f = message.getTeleopNavSourceInfoHealth();
  if (f) {
    writer.writeBool(
      201,
      f
    );
  }
  f = message.getEnableAxonMarkersRfd();
  if (f) {
    writer.writeBool(
      202,
      f
    );
  }
  f = message.getEnableFpvOnMap();
  if (f) {
    writer.writeBool(
      203,
      f
    );
  }
  f = message.getGimbalPitchResetShortcut();
  if (f) {
    writer.writeBool(
      206,
      f
    );
  }
  f = message.getR47ShowMissionPlanners();
  if (f) {
    writer.writeBool(
      208,
      f
    );
  }
  f = message.getRfdControllerMaxSpeedParity();
  if (f) {
    writer.writeBool(
      209,
      f
    );
  }
  f = message.getEnableArStreetOverlays();
  if (f) {
    writer.writeBool(
      210,
      f
    );
  }
  f = message.getEnableRfdHudCompass();
  if (f) {
    writer.writeBool(
      213,
      f
    );
  }
  f = message.getEnableRfdHudAirspeedAltitude();
  if (f) {
    writer.writeBool(
      216,
      f
    );
  }
  f = message.getMoveVehicleLaunchModalVideoFeed();
  if (f) {
    writer.writeBool(
      220,
      f
    );
  }
  f = message.getEnableDockTransitPoint();
  if (f) {
    writer.writeBool(
      222,
      f
    );
  }
  f = message.getUsePathfinderFlyToPointRfd();
  if (f) {
    writer.writeBool(
      227,
      f
    );
  }
  f = message.getMediaAvailableForFlightAlert();
  if (f) {
    writer.writeBool(
      228,
      f
    );
  }
  f = message.getDfrStockSettings();
  if (f) {
    writer.writeBool(
      232,
      f
    );
  }
  f = message.getCustomer2CustomMapboxMapStyles();
  if (f) {
    writer.writeBool(
      234,
      f
    );
  }
  f = message.getRfdConnectivitySettingsTab();
  if (f) {
    writer.writeBool(
      236,
      f
    );
  }
  f = message.getMissionEditorNightAutonomy();
  if (f) {
    writer.writeBool(
      237,
      f
    );
  }
  f = message.getRfdParachuteAttachmentUi();
  if (f) {
    writer.writeBool(
      238,
      f
    );
  }
  f = message.getShowCloudSimulatorControls();
  if (f) {
    writer.writeBool(
      239,
      f
    );
  }
  f = message.getMissionSharingCustomerPortal();
  if (f) {
    writer.writeBool(
      240,
      f
    );
  }
  f = message.getUseImprovedFlightStatusWorkflow();
  if (f) {
    writer.writeBool(
      243,
      f
    );
  }
  f = message.getRfdTelemetryStats();
  if (f) {
    writer.writeBool(
      247,
      f
    );
  }
  f = message.getShowOperationsAreaInternalMapboxStyles();
  if (f) {
    writer.writeBool(
      248,
      f
    );
  }
  f = message.getActivateStrobeLightsOnLaunchRfd();
  if (f) {
    writer.writeBool(
      249,
      f
    );
  }
  f = message.getMissionDocumentsApi();
  if (f) {
    writer.writeBool(
      250,
      f
    );
  }
  f = message.getFleetPageSdCardFormatting();
  if (f) {
    writer.writeBool(
      251,
      f
    );
  }
  f = message.getEnableMultidroneOperations();
  if (f) {
    writer.writeBool(
      252,
      f
    );
  }
  f = message.getControlKeyDragWaypointVertical();
  if (f) {
    writer.writeBool(
      254,
      f
    );
  }
  f = message.getShowTerrainAndBldgsToggleInFleetPage();
  if (f) {
    writer.writeBool(
      255,
      f
    );
  }
  f = message.getShowOverlappingDockWifiChannelsFleetPage();
  if (f) {
    writer.writeBool(
      259,
      f
    );
  }
  f = message.getShowInternalMapboxStyles3();
  if (f) {
    writer.writeBool(
      261,
      f
    );
  }
  f = message.getFixedLocationRid();
  if (f) {
    writer.writeBool(
      262,
      f
    );
  }
  f = message.getTeleopPilotKeepAlive();
  if (f) {
    writer.writeBool(
      264,
      f
    );
  }
  f = message.getEnableRtkSupport();
  if (f) {
    writer.writeBool(
      272,
      f
    );
  }
  f = message.getCityCustomerMapboxMapStyles();
  if (f) {
    writer.writeBool(
      274,
      f
    );
  }
  f = message.getLinkLossAlertLevelCaution();
  if (f) {
    writer.writeBool(
      276,
      f
    );
  }
  f = message.getEnableSetupFlights();
  if (f) {
    writer.writeBool(
      288,
      f
    );
  }
  f = message.getEuropeanUnion();
  if (f) {
    writer.writeBool(
      289,
      f
    );
  }
  f = message.getEnableCreateMarkerInteractionRfd();
  if (f) {
    writer.writeBool(
      292,
      f
    );
  }
  f = message.getDronesenseIntegrationSetup();
  if (f) {
    writer.writeBool(
      293,
      f
    );
  }
  f = message.getEnableC18MicrohardOfflineConfiguration();
  if (f) {
    writer.writeBool(
      295,
      f
    );
  }
  f = message.getCustomMapLayersExternal();
  if (f) {
    writer.writeBool(
      296,
      f
    );
  }
  f = message.getCustomMapLayersInternal();
  if (f) {
    writer.writeBool(
      297,
      f
    );
  }
  f = message.getFilterMarkersInRfdSidebar();
  if (f) {
    writer.writeBool(
      303,
      f
    );
  }
  f = message.getDfrCommand();
  if (f) {
    writer.writeBool(
      305,
      f
    );
  }
  f = message.getMissionDetailsAboveSkillsSwitcher();
  if (f) {
    writer.writeBool(
      306,
      f
    );
  }
  f = message.getMultiBatteryMissions();
  if (f) {
    writer.writeBool(
      307,
      f
    );
  }
  f = message.getSwapToX10DockCamOnLanding();
  if (f) {
    writer.writeBool(
      308,
      f
    );
  }
  f = message.getEnableRfdDedrone();
  if (f) {
    writer.writeBool(
      310,
      f
    );
  }
  f = message.getEnableRfdAdsbRecording();
  if (f) {
    writer.writeBool(
      311,
      f
    );
  }
  f = message.getMissionEditorShowInternalNavigationModeOptions();
  if (f) {
    writer.writeBool(
      313,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseTwoUi();
  if (f) {
    writer.writeBool(
      314,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseTwoPointFiveUi();
  if (f) {
    writer.writeBool(
      315,
      f
    );
  }
  f = message.getEnableDfrCommandPhaseThreeUi();
  if (f) {
    writer.writeBool(
      316,
      f
    );
  }
  f = message.getEnableDfrOrgBasedLivekitRoom();
  if (f) {
    writer.writeBool(
      317,
      f
    );
  }
  f = message.getX10DefaultsForGpsInitWaypoint();
  if (f) {
    writer.writeBool(
      318,
      f
    );
  }
  f = message.getEnableProperArSync();
  if (f) {
    writer.writeBool(
      324,
      f
    );
  }
  f = message.getEnableRfdViewLookatPoint();
  if (f) {
    writer.writeBool(
      329,
      f
    );
  }
  f = message.getEnableRfdSetLookatPoint();
  if (f) {
    writer.writeBool(
      330,
      f
    );
  }
  f = message.getSimulateRemoteOnPremOrg();
  if (f) {
    writer.writeBool(
      333,
      f
    );
  }
  f = message.getMultiOrgUsersRpic();
  if (f) {
    writer.writeBool(
      337,
      f
    );
  }
  f = message.getMarkersApi();
  if (f) {
    writer.writeBool(
      339,
      f
    );
  }
  f = message.getAllowDirectDeviceAdoption();
  if (f) {
    writer.writeBool(
      342,
      f
    );
  }
  f = message.getEnableDocklessSites();
  if (f) {
    writer.writeBool(
      343,
      f
    );
  }
  f = message.getEnableTeleopInIframe();
  if (f) {
    writer.writeBool(
      347,
      f
    );
  }
  f = message.getEnableDfrDockviewLayout();
  if (f) {
    writer.writeBool(
      348,
      f
    );
  }
  f = message.getEnableCustomerManagedSessionLengths();
  if (f) {
    writer.writeBool(
      349,
      f
    );
  }
  f = message.getEnableDispatchRespondHere();
  if (f) {
    writer.writeBool(
      352,
      f
    );
  }
  f = message.getDeploymentEngineerMissionsInternal();
  if (f) {
    writer.writeBool(
      355,
      f
    );
  }
  f = message.getSetTakePhotoWaitForFocusToConverge();
  if (f) {
    writer.writeBool(
      357,
      f
    );
  }
  f = message.getEnableValidationOfOnDemandMission();
  if (f) {
    writer.writeBool(
      360,
      f
    );
  }
  f = message.getEnableAxonWatchMeDemo();
  if (f) {
    writer.writeBool(
      361,
      f
    );
  }
  f = message.getEnableIncidentsStateUi();
  if (f) {
    writer.writeBool(
      363,
      f
    );
  }
  f = message.getEnablePlanningAroundGeofencesFlyToPointRfd();
  if (f) {
    writer.writeBool(
      364,
      f
    );
  }
  f = message.getHiveChannelConflictPrevention();
  if (f) {
    writer.writeBool(
      368,
      f
    );
  }
  f = message.getUnifiedMissionEditor();
  if (f) {
    writer.writeBool(
      370,
      f
    );
  }
  f = message.getMissionsCloudToController();
  if (f) {
    writer.writeBool(
      371,
      f
    );
  }
  f = message.getEnableWaypointMetricsWorkflow();
  if (f) {
    writer.writeBool(
      372,
      f
    );
  }
  f = message.getEnablePropellerTypeSpecification();
  if (f) {
    writer.writeBool(
      373,
      f
    );
  }
  f = message.getImprovedLandingButtons();
  if (f) {
    writer.writeBool(
      374,
      f
    );
  }
  f = message.getEnableCancelIncidentResponseModal();
  if (f) {
    writer.writeBool(
      376,
      f
    );
  }
  f = message.getDisplayCellularCarrierInfo();
  if (f) {
    writer.writeBool(
      378,
      f
    );
  }
  f = message.getEnableUnsupportedBrowserWarning();
  if (f) {
    writer.writeBool(
      379,
      f
    );
  }
  f = message.getEnableExtraAccessModes();
  if (f) {
    writer.writeBool(
      380,
      f
    );
  }
  f = message.getEnableCustomMapLayersBackend();
  if (f) {
    writer.writeBool(
      381,
      f
    );
  }
  f = message.getReverseGeocodeMarkersOnRead();
  if (f) {
    writer.writeBool(
      383,
      f
    );
  }
  f = message.getEditOrgFlightPolicyNondocked();
  if (f) {
    writer.writeBool(
      385,
      f
    );
  }
  f = message.getSitesImprovements525();
  if (f) {
    writer.writeBool(
      387,
      f
    );
  }
  f = message.getCloudRel5UiUpdates();
  if (f) {
    writer.writeBool(
      388,
      f
    );
  }
  f = message.getShowFileReleaseUi();
  if (f) {
    writer.writeBool(
      389,
      f
    );
  }
  f = message.getUseX10rev1AndUnknownAcceleratedPropWearAlert();
  if (f) {
    writer.writeBool(
      390,
      f
    );
  }
  f = message.getUseX10rev2AcceleratedPropWearAlert();
  if (f) {
    writer.writeBool(
      391,
      f
    );
  }
  f = message.getRtkEarlyAccessProgram();
  if (f) {
    writer.writeBool(
      392,
      f
    );
  }
  f = message.getNewCloudNavigation();
  if (f) {
    writer.writeBool(
      393,
      f
    );
  }
  f = message.getApiObservability();
  if (f) {
    writer.writeBool(
      394,
      f
    );
  }
  f = message.getNewIntegrationsUi();
  if (f) {
    writer.writeBool(
      395,
      f
    );
  }
  f = message.getUpdatedCreateOrganizationModal();
  if (f) {
    writer.writeBool(
      397,
      f
    );
  }
  f = message.getCloudSimAutomaticSiteSetup();
  if (f) {
    writer.writeBool(
      398,
      f
    );
  }
  f = message.getEnablePostFlightReports();
  if (f) {
    writer.writeBool(
      402,
      f
    );
  }
  f = message.getEnableDfrOutcomesSurvey();
  if (f) {
    writer.writeBool(
      406,
      f
    );
  }
  f = message.getRfdStreamlineNotifications();
  if (f) {
    writer.writeBool(
      407,
      f
    );
  }
  f = message.getEnableBatteryFrettingAlerts();
  if (f) {
    writer.writeBool(
      409,
      f
    );
  }
  f = message.getIncludeCaseIdsInAxonEvidenceTitle();
  if (f) {
    writer.writeBool(
      411,
      f
    );
  }
  f = message.getShowInternalFlightDeckCommands();
  if (f) {
    writer.writeBool(
      412,
      f
    );
  }
  f = message.getDisableEmailLogins();
  if (f) {
    writer.writeBool(
      416,
      f
    );
  }
  f = message.getMultipleMediaSyncPolicies();
  if (f) {
    writer.writeBool(
      420,
      f
    );
  }
  f = message.getShowA22DetailsInUi();
  if (f) {
    writer.writeBool(
      422,
      f
    );
  }
  f = message.getSubjectTracking();
  if (f) {
    writer.writeBool(
      424,
      f
    );
  }
  f = message.getAssetInspectionMissionPlanningV0();
  if (f) {
    writer.writeBool(
      425,
      f
    );
  }
  f = message.getEnablePreFlightChecklists();
  if (f) {
    writer.writeBool(
      426,
      f
    );
  }
  f = message.getBrandingDfrCommand();
  if (f) {
    writer.writeBool(
      427,
      f
    );
  }
  f = message.getEnableSurfaceScanSkillTeleop();
  if (f) {
    writer.writeBool(
      429,
      f
    );
  }
  f = message.getAutonomyWidgetRfd();
  if (f) {
    writer.writeBool(
      430,
      f
    );
  }
  f = message.getShowPropellerHoursTrackingOverrideSetting();
  if (f) {
    writer.writeBool(
      431,
      f
    );
  }
  f = message.getDockComputeReplacement();
  if (f) {
    writer.writeBool(
      432,
      f
    );
  }
  f = message.getAllowScanPlaneOffsetForMapCapture();
  if (f) {
    writer.writeBool(
      435,
      f
    );
  }
  f = message.getRtkPpkRfdTelemetry();
  if (f) {
    writer.writeBool(
      436,
      f
    );
  }
  f = message.getSubjectTrackingForEngineering();
  if (f) {
    writer.writeBool(
      437,
      f
    );
  }
  f = message.getEnableMultidroneAscendFy26();
  if (f) {
    writer.writeBool(
      440,
      f
    );
  }
  f = message.getCloudSimRecreateExperience();
  if (f) {
    writer.writeBool(
      444,
      f
    );
  }
  f = message.getOnpremManagementOrganization();
  if (f) {
    writer.writeBool(
      446,
      f
    );
  }
  f = message.getShowAdaptiveCaptureSettingsUi();
  if (f) {
    writer.writeBool(
      448,
      f
    );
  }
  f = message.getEnableFlightSystemRebootScheduler();
  if (f) {
    writer.writeBool(
      449,
      f
    );
  }
  f = message.getEnableCloudSimTailscale();
  if (f) {
    writer.writeBool(
      450,
      f
    );
  }
  f = message.getGetPermissionFromSimTeamFirstEnableR71CloudSimulator();
  if (f) {
    writer.writeBool(
      451,
      f
    );
  }
  f = message.getEditOrgCaptureSettingsNondocked();
  if (f) {
    writer.writeBool(
      452,
      f
    );
  }
  f = message.getRenderBackendScanPlan();
  if (f) {
    writer.writeBool(
      453,
      f
    );
  }
  f = message.getEnableCloudDrivenEncryption();
  if (f) {
    writer.writeBool(
      454,
      f
    );
  }
  f = message.getMissionDeviceSwitching();
  if (f) {
    writer.writeBool(
      455,
      f
    );
  }
  f = message.getAssetSettingsView();
  if (f) {
    writer.writeBool(
      456,
      f
    );
  }
  f = message.getCloudSimShow2025AscendVersions();
  if (f) {
    writer.writeBool(
      457,
      f
    );
  }
  f = message.getMissionSettingsFlightPolicyV0();
  if (f) {
    writer.writeBool(
      458,
      f
    );
  }
  f = message.getApiPortalDownloadParity();
  if (f) {
    writer.writeBool(
      459,
      f
    );
  }
  f = message.getGeofenceAwareMissionPlanning();
  if (f) {
    writer.writeBool(
      460,
      f
    );
  }
  f = message.getInmAscendFy26();
  if (f) {
    writer.writeBool(
      461,
      f
    );
  }
  f = message.getApplyC18IrqStormCloudOverridesToOrg();
  if (f) {
    writer.writeBool(
      462,
      f
    );
  }
  f = message.getAglFromVehicleRfd();
  if (f) {
    writer.writeBool(
      463,
      f
    );
  }
  f = message.getStopSendingAutoRecordTrueFromRfd();
  if (f) {
    writer.writeBool(
      464,
      f
    );
  }
  f = message.getUseDeviceSoftwareCompatibilityMatrix();
  if (f) {
    writer.writeBool(
      465,
      f
    );
  }
  f = message.getRfdEarlyPrep();
  if (f) {
    writer.writeBool(
      466,
      f
    );
  }
  f = message.getRfdPathfinderDisablesNightsense();
  if (f) {
    writer.writeBool(
      467,
      f
    );
  }
  f = message.getAxonAlprIntegration();
  if (f) {
    writer.writeBool(
      468,
      f
    );
  }
  f = message.getEnableComputeMissionTrajectory();
  if (f) {
    writer.writeBool(
      469,
      f
    );
  }
  f = message.getEnable1hzDispatchTelemetryDownsampling();
  if (f) {
    writer.writeBool(
      470,
      f
    );
  }
  f = message.getShowBitratePresetInFlightPolicy();
  if (f) {
    writer.writeBool(
      471,
      f
    );
  }
  f = message.getHideSafeLandingIfNoneSet();
  if (f) {
    writer.writeBool(
      472,
      f
    );
  }
  f = message.getMissionEditorHeightFrameSelector();
  if (f) {
    writer.writeBool(
      474,
      f
    );
  }
  f = message.getFususCadIntegration();
  if (f) {
    writer.writeBool(
      475,
      f
    );
  }
  f = message.getEnableAlertText();
  if (f) {
    writer.writeBool(
      476,
      f
    );
  }
  f = message.getMpegTsSettings();
  if (f) {
    writer.writeBool(
      477,
      f
    );
  }
  f = message.getExposeOrgTier();
  if (f) {
    writer.writeBool(
      478,
      f
    );
  }
  f = message.getUndoUpsertMarkerOptimization();
  if (f) {
    writer.writeBool(
      480,
      f
    );
  }
  f = message.getNomadMapsMissionEditor();
  if (f) {
    writer.writeBool(
      481,
      f
    );
  }
  f = message.getUnifiedPostMissionActions();
  if (f) {
    writer.writeBool(
      482,
      f
    );
  }
  f = message.getHardwareKeyEncryptionEnabled();
  if (f) {
    writer.writeBool(
      484,
      f
    );
  }
  f = message.getWriteAddressForBodycams();
  if (f) {
    writer.writeBool(
      485,
      f
    );
  }
  f = message.getDedroneIntegration();
  if (f) {
    writer.writeBool(
      486,
      f
    );
  }
  f = message.getEnableVideoFeedbackSurvey();
  if (f) {
    writer.writeBool(
      487,
      f
    );
  }
  f = message.getParaverseArcadePostFlightForm();
  if (f) {
    writer.writeBool(
      488,
      f
    );
  }
  f = message.getEnableMultidroneRfd();
  if (f) {
    writer.writeBool(
      489,
      f
    );
  }
  f = message.getAllowDocklessLiveMissionPlanning();
  if (f) {
    writer.writeBool(
      490,
      f
    );
  }
  f = message.getArSyncInWorker();
  if (f) {
    writer.writeBool(
      491,
      f
    );
  }
  f = message.getRfdEnableDroneDockName();
  if (f) {
    writer.writeBool(
      492,
      f
    );
  }
  f = message.getHiveAcs();
  if (f) {
    writer.writeBool(
      493,
      f
    );
  }
  f = message.getControllerSupportCloudEncryption();
  if (f) {
    writer.writeBool(
      494,
      f
    );
  }
  f = message.getExtendGeofenceVertexLimit();
  if (f) {
    writer.writeBool(
      495,
      f
    );
  }
  f = message.getSkillsSelectorInAutonomyWidget();
  if (f) {
    writer.writeBool(
      496,
      f
    );
  }
  f = message.getReactPerfFixes();
  if (f) {
    writer.writeBool(
      497,
      f
    );
  }
  f = message.getPathfinderBoundariesMenu();
  if (f) {
    writer.writeBool(
      499,
      f
    );
  }
  f = message.getRfdHigherMaxSpeed();
  if (f) {
    writer.writeBool(
      500,
      f
    );
  }
  f = message.getCadIdSyncing();
  if (f) {
    writer.writeBool(
      501,
      f
    );
  }
  f = message.getClearMarkersDispatchMap();
  if (f) {
    writer.writeBool(
      502,
      f
    );
  }
  f = message.getRfdPrimaryAltitudeSetting();
  if (f) {
    writer.writeBool(
      504,
      f
    );
  }
  f = message.getGen2G47ChargerEap();
  if (f) {
    writer.writeBool(
      507,
      f
    );
  }
  f = message.getEnableSentryAutodetection();
  if (f) {
    writer.writeBool(
      508,
      f
    );
  }
  f = message.getFixLivestreamMutation();
  if (f) {
    writer.writeBool(
      509,
      f
    );
  }
  f = message.getMarkersBackendFiltering();
  if (f) {
    writer.writeBool(
      511,
      f
    );
  }
  f = message.getSuppressAirTrafficAlertsWhenGrounded();
  if (f) {
    writer.writeBool(
      512,
      f
    );
  }
  f = message.getRfdOnSubdomain();
  if (f) {
    writer.writeBool(
      513,
      f
    );
  }
  f = message.getFleetMapViewEnhancements();
  if (f) {
    writer.writeBool(
      514,
      f
    );
  }
  f = message.getConsumablesUsageAlerts();
  if (f) {
    writer.writeBool(
      1812,
      f
    );
  }
  f = message.getSingleClickOtaExtended();
  if (f) {
    writer.writeBool(
      9001,
      f
    );
  }
  f = message.getCloudRel13UiUpdates();
  if (f) {
    writer.writeBool(
      518,
      f
    );
  }
  f = message.getAtlasPointsRfdV2();
  if (f) {
    writer.writeBool(
      520,
      f
    );
  }
  f = message.getMissionsInRfdV2();
  if (f) {
    writer.writeBool(
      521,
      f
    );
  }
  f = message.getMissionResumability();
  if (f) {
    writer.writeBool(
      522,
      f
    );
  }
  f = message.getPlaywrightBlankMapRendering();
  if (f) {
    writer.writeBool(
      523,
      f
    );
  }
  f = message.getCloudRelCayleyUiUpdates();
  if (f) {
    writer.writeBool(
      524,
      f
    );
  }
  f = message.getEnableRfdv2SidebarLayout();
  if (f) {
    writer.writeBool(
      525,
      f
    );
  }
  f = message.getEnablePathfinderBoundaryManagement();
  if (f) {
    writer.writeBool(
      526,
      f
    );
  }
  f = message.getShowDeviceFactoryResetUi();
  if (f) {
    writer.writeBool(
      527,
      f
    );
  }
  f = message.getShowProductImprovementConsentToggle();
  if (f) {
    writer.writeBool(
      528,
      f
    );
  }
  f = message.getEnableParaverseArcadeCreation();
  if (f) {
    writer.writeBool(
      529,
      f
    );
  }
  f = message.getNomadTrueOrthographicMode();
  if (f) {
    writer.writeBool(
      530,
      f
    );
  }
  f = message.getContentHintMotion();
  if (f) {
    writer.writeBool(
      532,
      f
    );
  }
  f = message.getManageAdsbAlertSettingsWithOrgOverride();
  if (f) {
    writer.writeBool(
      533,
      f
    );
  }
  f = message.getEnableAglGeofences();
  if (f) {
    writer.writeBool(
      534,
      f
    );
  }
  f = message.getEnableRfdv2SidebarStack();
  if (f) {
    writer.writeBool(
      535,
      f
    );
  }
  f = message.getFetchRecordingBodycamsOnly();
  if (f) {
    writer.writeBool(
      536,
      f
    );
  }
  f = message.getZeroLatencyControls();
  if (f) {
    writer.writeBool(
      537,
      f
    );
  }
  f = message.getEnableViewerCountFromRedis();
  if (f) {
    writer.writeBool(
      538,
      f
    );
  }
  f = message.getAtlasPointsRfdV2MarkersOnly();
  if (f) {
    writer.writeBool(
      539,
      f
    );
  }
  f = message.getRfdOnSubdomainForEngineering();
  if (f) {
    writer.writeBool(
      540,
      f
    );
  }
  f = message.getGamepadSubjectTracking();
  if (f) {
    writer.writeBool(
      541,
      f
    );
  }
  f = message.getFilterByHealthStatus();
  if (f) {
    writer.writeBool(
      542,
      f
    );
  }
  f = message.getFlatListOfHealthIssues();
  if (f) {
    writer.writeBool(
      543,
      f
    );
  }
  f = message.getIntegrateKmlImporterIntoMissionPlanning();
  if (f) {
    writer.writeBool(
      544,
      f
    );
  }
  f = message.getShotspotterIntegration();
  if (f) {
    writer.writeBool(
      546,
      f
    );
  }
  f = message.getEnableRfdV2ComingSoonBanner();
  if (f) {
    writer.writeBool(
      547,
      f
    );
  }
  f = message.getEnableFileAutoRetentionAndSoftDelete();
  if (f) {
    writer.writeBool(
      548,
      f
    );
  }
  f = message.getSplitUserMediaUploadProgress();
  if (f) {
    writer.writeBool(
      549,
      f
    );
  }
  f = message.getEnableCloudTakMarkers();
  if (f) {
    writer.writeBool(
      550,
      f
    );
  }
  f = message.getFlightSystemViewRedesign();
  if (f) {
    writer.writeBool(
      551,
      f
    );
  }
  f = message.getSitesGeofenceImportExport();
  if (f) {
    writer.writeBool(
      552,
      f
    );
  }
  f = message.getEnableMarkersGqlFederation();
  if (f) {
    writer.writeBool(
      553,
      f
    );
  }
  f = message.getAssetSurveyFromPhotos();
  if (f) {
    writer.writeBool(
      554,
      f
    );
  }
  f = message.getFlightDetailsPage();
  if (f) {
    writer.writeBool(
      555,
      f
    );
  }
  f = message.getDebounceLiveStreamAlert();
  if (f) {
    writer.writeBool(
      556,
      f
    );
  }
  f = message.getEnableRticMode();
  if (f) {
    writer.writeBool(
      557,
      f
    );
  }
  f = message.getEnableDeclarativeDockview();
  if (f) {
    writer.writeBool(
      558,
      f
    );
  }
  f = message.getEnableCustomRfdUrl();
  if (f) {
    writer.writeBool(
      559,
      f
    );
  }
  f = message.getEnableFlightPathVisualization();
  if (f) {
    writer.writeBool(
      560,
      f
    );
  }
  f = message.getEnableViewSalesforceSupportCases();
  if (f) {
    writer.writeBool(
      561,
      f
    );
  }
  f = message.getConsumablesReport();
  if (f) {
    writer.writeBool(
      562,
      f
    );
  }
  f = message.getFasterTtl();
  if (f) {
    writer.writeBool(
      563,
      f
    );
  }
  f = message.getEnablePlannedOperations();
  if (f) {
    writer.writeBool(
      564,
      f
    );
  }
  f = message.getEnableDockedRthDeconfliction();
  if (f) {
    writer.writeBool(
      565,
      f
    );
  }
  f = message.getEnableHistoricalMarkerFilters();
  if (f) {
    writer.writeBool(
      566,
      f
    );
  }
  f = message.getEnableOperationsV0();
  if (f) {
    writer.writeBool(
      567,
      f
    );
  }
  f = message.getMissionRunning();
  if (f) {
    writer.writeBool(
      568,
      f
    );
  }
  f = message.getShowFileAutoDeletionUx();
  if (f) {
    writer.writeBool(
      569,
      f
    );
  }
  f = message.getIntegrationUiImprovements();
  if (f) {
    writer.writeBool(
      570,
      f
    );
  }
  f = message.getBetterSupportLogUpload();
  if (f) {
    writer.writeBool(
      571,
      f
    );
  }
  f = message.getFrontendBeta();
  if (f) {
    writer.writeBool(
      572,
      f
    );
  }
  f = message.getShowLastPilotFlown();
  if (f) {
    writer.writeBool(
      573,
      f
    );
  }
  f = message.getDisplayThemeSettingsView();
  if (f) {
    writer.writeBool(
      574,
      f
    );
  }
  f = message.getPilotDetailPage();
  if (f) {
    writer.writeBool(
      575,
      f
    );
  }
  f = message.getEnableNorthIndicator();
  if (f) {
    writer.writeBool(
      576,
      f
    );
  }
  f = message.getHealthStatusChangedAlert();
  if (f) {
    writer.writeBool(
      577,
      f
    );
  }
  f = message.getRfdCollapsibleSidebar();
  if (f) {
    writer.writeBool(
      579,
      f
    );
  }
  f = message.getRfdPinnableSidebar();
  if (f) {
    writer.writeBool(
      580,
      f
    );
  }
  f = message.getEnableAglHeightCeiling();
  if (f) {
    writer.writeBool(
      578,
      f
    );
  }
  f = message.getDisplayPathfinderBoundariesInMaps();
  if (f) {
    writer.writeBool(
      581,
      f
    );
  }
  f = message.getOrgRegionTransfer();
  if (f) {
    writer.writeBool(
      582,
      f
    );
  }
  f = message.getShowParachuteRequiredSetting();
  if (f) {
    writer.writeBool(
      583,
      f
    );
  }
  f = message.getCloudRtkProfiles();
  if (f) {
    writer.writeBool(
      584,
      f
    );
  }
  f = message.getRfdCockpitV2();
  if (f) {
    writer.writeBool(
      585,
      f
    );
  }
  f = message.getShowAuditEvents();
  if (f) {
    writer.writeBool(
      586,
      f
    );
  }
  f = message.getOverrideMotionApiToLegacy();
  if (f) {
    writer.writeBool(
      587,
      f
    );
  }
  f = message.getRfd3dCockpit();
  if (f) {
    writer.writeBool(
      588,
      f
    );
  }
  f = message.getPilotLeaderboard();
  if (f) {
    writer.writeBool(
      589,
      f
    );
  }
  f = message.getCustomMapLayersFromCloud();
  if (f) {
    writer.writeBool(
      590,
      f
    );
  }
  f = message.getEnableAglWaypointAltitudesRfd();
  if (f) {
    writer.writeBool(
      591,
      f
    );
  }
  f = message.getCompleteStacknavSidebar();
  if (f) {
    writer.writeBool(
      592,
      f
    );
  }
  f = message.getEnableMulticockpitRfd();
  if (f) {
    writer.writeBool(
      593,
      f
    );
  }
  f = message.getTakIntegration();
  if (f) {
    writer.writeBool(
      594,
      f
    );
  }
  f = message.getEnableTogglingGeofencesRfd();
  if (f) {
    writer.writeBool(
      595,
      f
    );
  }
  f = message.getReliableCommandeering();
  if (f) {
    writer.writeBool(
      596,
      f
    );
  }
  f = message.getEnableMarkerFilterSettings();
  if (f) {
    writer.writeBool(
      597,
      f
    );
  }
  f = message.getRfdLaunchWhenReady();
  if (f) {
    writer.writeBool(
      598,
      f
    );
  }
  f = message.getEnableCloudNtrip();
  if (f) {
    writer.writeBool(
      599,
      f
    );
  }
  f = message.getEnableAcademyOnlineCode();
  if (f) {
    writer.writeBool(
      600,
      f
    );
  }
  f = message.getEvidenceViaGo();
  if (f) {
    writer.writeBool(
      601,
      f
    );
  }
  f = message.getEnableMultidroneAdsbRfd();
  if (f) {
    writer.writeBool(
      602,
      f
    );
  }
  f = message.getWarningEnforcementMode();
  if (f) {
    writer.writeBool(
      603,
      f
    );
  }
  f = message.getWaypointDragReorder();
  if (f) {
    writer.writeBool(
      604,
      f
    );
  }
  f = message.getAiAgentRfd();
  if (f) {
    writer.writeBool(
      605,
      f
    );
  }
  f = message.getCloudRel14UiUpdates();
  if (f) {
    writer.writeBool(
      606,
      f
    );
  }
  f = message.getUseAdsbRegulatoryManagerInfo();
  if (f) {
    writer.writeBool(
      607,
      f
    );
  }
  f = message.getEnableAdsbRegulatoryManagerSettings();
  if (f) {
    writer.writeBool(
      608,
      f
    );
  }
  f = message.getEditOrgFlightPolicyR10();
  if (f) {
    writer.writeBool(
      609,
      f
    );
  }
  f = message.getOfflinePortal();
  if (f) {
    writer.writeBool(
      610,
      f
    );
  }
  f = message.getRfdDisableDataThrottle();
  if (f) {
    writer.writeBool(
      611,
      f
    );
  }
  f = message.getTapToFocusRfd();
  if (f) {
    writer.writeBool(
      612,
      f
    );
  }
  f = message.getAutomaticVexcelDsmIngest();
  if (f) {
    writer.writeBool(
      613,
      f
    );
  }
  f = message.getEnableMultiDroneRid();
  if (f) {
    writer.writeBool(
      614,
      f
    );
  }
  f = message.getPart107Certification();
  if (f) {
    writer.writeBool(
      615,
      f
    );
  }
  f = message.getEnableInlineMarkerEditing();
  if (f) {
    writer.writeBool(
      616,
      f
    );
  }
  f = message.getTransparencyDashboardV2();
  if (f) {
    writer.writeBool(
      617,
      f
    );
  }
  f = message.getEnableOutOfService();
  if (f) {
    writer.writeBool(
      618,
      f
    );
  }
  f = message.getTagSettingsView();
  if (f) {
    writer.writeBool(
      619,
      f
    );
  }
  f = message.getMissionEditorNomadMapDevSwitch();
  if (f) {
    writer.writeBool(
      620,
      f
    );
  }
  f = message.getCloudRtkProfileApiKeySupport();
  if (f) {
    writer.writeBool(
      621,
      f
    );
  }
  f = message.getEnablePeriodicBkScan();
  if (f) {
    writer.writeBool(
      622,
      f
    );
  }
  f = message.getRunAxonPollerOnSkypoller();
  if (f) {
    writer.writeBool(
      623,
      f
    );
  }
  f = message.getEnableGlobalAirspaceDeconfliction();
  if (f) {
    writer.writeBool(
      624,
      f
    );
  }
  f = message.getShowSsoJitToggle();
  if (f) {
    writer.writeBool(
      625,
      f
    );
  }
  f = message.getShowAfRegionRfd();
  if (f) {
    writer.writeBool(
      626,
      f
    );
  }
  f = message.getConsumablesV2Panel();
  if (f) {
    writer.writeBool(
      627,
      f
    );
  }
  f = message.getUseFoundryClient();
  if (f) {
    writer.writeBool(
      628,
      f
    );
  }
  f = message.getEnablePowerLineGeofences();
  if (f) {
    writer.writeBool(
      629,
      f
    );
  }
  f = message.getEnableGeoLookat();
  if (f) {
    writer.writeBool(
      630,
      f
    );
  }
  f = message.getSetupScheduledFlightsFromCloud();
  if (f) {
    writer.writeBool(
      631,
      f
    );
  }
  f = message.getShowH265Toggle();
  if (f) {
    writer.writeBool(
      632,
      f
    );
  }
  f = message.getRfdEnableControllerCustomization();
  if (f) {
    writer.writeBool(
      633,
      f
    );
  }
  f = message.getRgScopedIntegrations();
  if (f) {
    writer.writeBool(
      634,
      f
    );
  }
  f = message.getFusionPlusOta();
  if (f) {
    writer.writeBool(
      635,
      f
    );
  }
  f = message.getEnableDockCirclesLayer();
  if (f) {
    writer.writeBool(
      636,
      f
    );
  }
  f = message.getRfdEnableRthOptimalSlider();
  if (f) {
    writer.writeBool(
      637,
      f
    );
  }
  f = message.getPreReleaseFeatureControls();
  if (f) {
    writer.writeBool(
      638,
      f
    );
  }
  f = message.getEnableManualClipCapture();
  if (f) {
    writer.writeBool(
      639,
      f
    );
  }
  f = message.getEnableWeatherInference();
  if (f) {
    writer.writeBool(
      640,
      f
    );
  }
  f = message.getEnableDroneInspectionTracking();
  if (f) {
    writer.writeBool(
      641,
      f
    );
  }
};


/**
 * optional bool vehicle_teleoperation = 3;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleTeleoperation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleTeleoperation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool automatic_file_upload_page = 4;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticFileUploadPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticFileUploadPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool live_streaming = 6;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLiveStreaming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLiveStreaming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool axon_media_integration = 7;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonMediaIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonMediaIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool missions_page = 8;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool axon_respond_integration = 13;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonRespondIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonRespondIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool view_offline_settings = 14;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getViewOfflineSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setViewOfflineSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool configure_obstacle_margin = 15;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getConfigureObstacleMargin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setConfigureObstacleMargin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool dro_internal = 16;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDroInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDroInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool annotations = 21;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAnnotations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAnnotations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool cloud_inspect_page = 22;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudInspectPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudInspectPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool mission_media_viewer = 23;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionMediaViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionMediaViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool automatic_cloud_photogrammetry = 26;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticCloudPhotogrammetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticCloudPhotogrammetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional bool dock_location_update = 27;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDockLocationUpdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDockLocationUpdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool disable_teleop_landing_prompt = 29;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableTeleopLandingPrompt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableTeleopLandingPrompt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool dro_teleop_run_mission_json = 31;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDroTeleopRunMissionJson = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDroTeleopRunMissionJson = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional bool hide_land_now_during_rtd = 33;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHideLandNowDuringRtd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHideLandNowDuringRtd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional bool remote_video_api_access = 36;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRemoteVideoApiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRemoteVideoApiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional bool allow_twilight_flight = 38;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowTwilightFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowTwilightFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional bool allow_backtracking_rtx = 39;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowBacktrackingRtx = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowBacktrackingRtx = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional bool cloud_ota = 40;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudOta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudOta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};


/**
 * optional bool teleop_debug_menu = 41;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopDebugMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopDebugMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};


/**
 * optional bool qos_skybus_channel_setting = 42;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getQosSkybusChannelSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setQosSkybusChannelSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};


/**
 * optional bool post_refactor_mission_editor = 43;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPostRefactorMissionEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPostRefactorMissionEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};


/**
 * optional bool network_debugging_tools = 46;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNetworkDebuggingTools = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 46, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNetworkDebuggingTools = function(value) {
  return jspb.Message.setProto3BooleanField(this, 46, value);
};


/**
 * optional bool full_height_video_enabled = 47;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFullHeightVideoEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 47, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFullHeightVideoEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 47, value);
};


/**
 * optional bool nav_height_above_ground_enabled = 49;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNavHeightAboveGroundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 49, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNavHeightAboveGroundEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 49, value);
};


/**
 * optional bool internal_theme_toggle = 51;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getInternalThemeToggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 51, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setInternalThemeToggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 51, value);
};


/**
 * optional bool customer_custom_mapbox_map_styles = 53;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomerCustomMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 53, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomerCustomMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 53, value);
};


/**
 * optional bool show_vehicle_faults_teleop = 63;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowVehicleFaultsTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 63, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowVehicleFaultsTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 63, value);
};


/**
 * optional bool show_vps_info = 66;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowVpsInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 66, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowVpsInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 66, value);
};


/**
 * optional bool teleop_ar_v2 = 67;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopArV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 67, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopArV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 67, value);
};


/**
 * optional bool mission_control_api = 68;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionControlApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 68, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionControlApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 68, value);
};


/**
 * optional bool surface_scan_missions = 71;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSurfaceScanMissions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 71, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSurfaceScanMissions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 71, value);
};


/**
 * optional bool show_april_tag_settings = 72;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAprilTagSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 72, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAprilTagSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 72, value);
};


/**
 * optional bool show_range_limit_settings = 80;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowRangeLimitSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 80, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowRangeLimitSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 80, value);
};


/**
 * optional bool site_mapper = 85;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSiteMapper = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 85, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSiteMapper = function(value) {
  return jspb.Message.setProto3BooleanField(this, 85, value);
};


/**
 * optional bool show_band_selection_settings = 86;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowBandSelectionSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 86, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowBandSelectionSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 86, value);
};


/**
 * optional bool fly_now_no_automatic_run_mode_switching = 87;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFlyNowNoAutomaticRunModeSwitching = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 87, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFlyNowNoAutomaticRunModeSwitching = function(value) {
  return jspb.Message.setProto3BooleanField(this, 87, value);
};


/**
 * optional bool ar_video_sync = 88;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getArVideoSync = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 88, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setArVideoSync = function(value) {
  return jspb.Message.setProto3BooleanField(this, 88, value);
};


/**
 * optional bool mission_results_3d_viewer = 89;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionResults3dViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 89, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionResults3dViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 89, value);
};


/**
 * optional bool automatic_ncpg_photogrammetry = 92;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticNcpgPhotogrammetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 92, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticNcpgPhotogrammetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 92, value);
};


/**
 * optional bool executive_action_hotkeys = 93;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getExecutiveActionHotkeys = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 93, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setExecutiveActionHotkeys = function(value) {
  return jspb.Message.setProto3BooleanField(this, 93, value);
};


/**
 * optional bool vehicle_type_based_axon_sessions = 94;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVehicleTypeBasedAxonSessions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 94, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVehicleTypeBasedAxonSessions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 94, value);
};


/**
 * optional bool always_show_camera_settings = 99;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAlwaysShowCameraSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 99, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAlwaysShowCameraSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 99, value);
};


/**
 * optional bool teleop_waypoint_commands = 101;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopWaypointCommands = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 101, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopWaypointCommands = function(value) {
  return jspb.Message.setProto3BooleanField(this, 101, value);
};


/**
 * optional bool prop_guards_enablement = 108;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPropGuardsEnablement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 108, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPropGuardsEnablement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 108, value);
};


/**
 * optional bool remote_pilot_api_access = 111;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRemotePilotApiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 111, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRemotePilotApiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 111, value);
};


/**
 * optional bool show_view_flight_deck_button = 112;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowViewFlightDeckButton = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 112, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowViewFlightDeckButton = function(value) {
  return jspb.Message.setProto3BooleanField(this, 112, value);
};


/**
 * optional bool twilight_mode_fast_flight = 113;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTwilightModeFastFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 113, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTwilightModeFastFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 113, value);
};


/**
 * optional bool standalone_map_page = 114;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getStandaloneMapPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 114, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setStandaloneMapPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 114, value);
};


/**
 * optional bool lost_comms_timeout_setting_teleop = 116;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLostCommsTimeoutSettingTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 116, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLostCommsTimeoutSettingTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 116, value);
};


/**
 * optional bool teleop_fast_flight = 117;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopFastFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 117, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopFastFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 117, value);
};


/**
 * optional bool allow_edit_adsb_settings = 119;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowEditAdsbSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 119, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowEditAdsbSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 119, value);
};


/**
 * optional bool show_teleop_idle_modal = 121;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTeleopIdleModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 121, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTeleopIdleModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 121, value);
};


/**
 * optional bool skydio_extend = 122;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSkydioExtend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 122, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSkydioExtend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 122, value);
};


/**
 * optional bool support_menu_v2 = 123;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSupportMenuV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 123, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSupportMenuV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 123, value);
};


/**
 * optional bool geofence_enforcement_in_cloud = 125;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGeofenceEnforcementInCloud = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 125, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGeofenceEnforcementInCloud = function(value) {
  return jspb.Message.setProto3BooleanField(this, 125, value);
};


/**
 * optional bool teleop_third_person_view = 129;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopThirdPersonView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 129, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopThirdPersonView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 129, value);
};


/**
 * optional bool show_teleop_circular_battery_widget = 132;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTeleopCircularBatteryWidget = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 132, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTeleopCircularBatteryWidget = function(value) {
  return jspb.Message.setProto3BooleanField(this, 132, value);
};


/**
 * optional bool structure_annotations_api = 134;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getStructureAnnotationsApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 134, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setStructureAnnotationsApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 134, value);
};


/**
 * optional bool own_org_groups = 138;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOwnOrgGroups = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 138, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOwnOrgGroups = function(value) {
  return jspb.Message.setProto3BooleanField(this, 138, value);
};


/**
 * optional bool teleop_commandeering_v2 = 139;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopCommandeeringV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 139, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopCommandeeringV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 139, value);
};


/**
 * optional bool ncpg_photogrammetry_use_tensor_rt_flow_model = 142;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNcpgPhotogrammetryUseTensorRtFlowModel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 142, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNcpgPhotogrammetryUseTensorRtFlowModel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 142, value);
};


/**
 * optional bool show_faa_mapbox_styles = 143;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowFaaMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 143, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowFaaMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 143, value);
};


/**
 * optional bool sites_structure_editor = 147;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSitesStructureEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 147, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSitesStructureEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 147, value);
};


/**
 * optional bool multi_mission_flight_tester = 148;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiMissionFlightTester = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 148, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiMissionFlightTester = function(value) {
  return jspb.Message.setProto3BooleanField(this, 148, value);
};


/**
 * optional bool x10_eo_camera_controls_parity_in_teleop = 154;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getX10EoCameraControlsParityInTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 154, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setX10EoCameraControlsParityInTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 154, value);
};


/**
 * optional bool no_obstacle_avoidance_in_teleop = 155;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNoObstacleAvoidanceInTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 155, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNoObstacleAvoidanceInTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 155, value);
};


/**
 * optional bool vps_map_datamodel_transition_read_from_new = 162;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVpsMapDatamodelTransitionReadFromNew = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 162, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVpsMapDatamodelTransitionReadFromNew = function(value) {
  return jspb.Message.setProto3BooleanField(this, 162, value);
};


/**
 * optional bool vps_map_datamodel_transition_write_to_both = 163;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getVpsMapDatamodelTransitionWriteToBoth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 163, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setVpsMapDatamodelTransitionWriteToBoth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 163, value);
};


/**
 * optional bool edit_org_flight_policy = 164;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgFlightPolicy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 164, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgFlightPolicy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 164, value);
};


/**
 * optional bool teleop_wheel_zoom = 165;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopWheelZoom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 165, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopWheelZoom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 165, value);
};


/**
 * optional bool multizone_site_geofences = 166;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultizoneSiteGeofences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 166, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultizoneSiteGeofences = function(value) {
  return jspb.Message.setProto3BooleanField(this, 166, value);
};


/**
 * optional bool teleop_bitrate_slider = 168;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopBitrateSlider = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 168, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopBitrateSlider = function(value) {
  return jspb.Message.setProto3BooleanField(this, 168, value);
};


/**
 * optional bool rid_feature_disabled = 171;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRidFeatureDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 171, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRidFeatureDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 171, value);
};


/**
 * optional bool safe_landing_points = 174;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSafeLandingPoints = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 174, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSafeLandingPoints = function(value) {
  return jspb.Message.setProto3BooleanField(this, 174, value);
};


/**
 * optional bool teleop_boost_mode = 177;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopBoostMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 177, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopBoostMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 177, value);
};


/**
 * optional bool teleop_crawl_mode = 178;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopCrawlMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 178, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopCrawlMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 178, value);
};


/**
 * optional bool show_operations_area_mapbox_styles = 180;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOperationsAreaMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 180, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOperationsAreaMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 180, value);
};


/**
 * optional bool barometer_height_mode = 183;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBarometerHeightMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 183, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBarometerHeightMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 183, value);
};


/**
 * optional bool graphiql_viewer = 186;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGraphiqlViewer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 186, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGraphiqlViewer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 186, value);
};


/**
 * optional bool enable_orbit_to_poi_rfd = 187;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableOrbitToPoiRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 187, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableOrbitToPoiRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 187, value);
};


/**
 * optional bool disable_cloud_config_signature_verification = 188;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableCloudConfigSignatureVerification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 188, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableCloudConfigSignatureVerification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 188, value);
};


/**
 * optional bool is_onprem_org = 189;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIsOnpremOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 189, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIsOnpremOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 189, value);
};


/**
 * optional bool enable_map_vehicle_followiing = 192;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMapVehicleFollowiing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 192, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMapVehicleFollowiing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 192, value);
};


/**
 * optional bool teleop_telemetry_heading_and_gimbal_pitch = 194;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopTelemetryHeadingAndGimbalPitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 194, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopTelemetryHeadingAndGimbalPitch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 194, value);
};


/**
 * optional bool media_page_kind_dropdown = 195;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaPageKindDropdown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 195, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaPageKindDropdown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 195, value);
};


/**
 * optional bool teleop_actions_toolbar = 196;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopActionsToolbar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 196, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopActionsToolbar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 196, value);
};


/**
 * optional bool enable_dock_landing_ar = 199;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockLandingAr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 199, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockLandingAr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 199, value);
};


/**
 * optional bool teleop_nav_source_info_health = 201;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopNavSourceInfoHealth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 201, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopNavSourceInfoHealth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 201, value);
};


/**
 * optional bool enable_axon_markers_rfd = 202;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAxonMarkersRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 202, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAxonMarkersRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 202, value);
};


/**
 * optional bool enable_fpv_on_map = 203;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFpvOnMap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 203, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFpvOnMap = function(value) {
  return jspb.Message.setProto3BooleanField(this, 203, value);
};


/**
 * optional bool gimbal_pitch_reset_shortcut = 206;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGimbalPitchResetShortcut = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 206, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGimbalPitchResetShortcut = function(value) {
  return jspb.Message.setProto3BooleanField(this, 206, value);
};


/**
 * optional bool r47_show_mission_planners = 208;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getR47ShowMissionPlanners = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 208, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setR47ShowMissionPlanners = function(value) {
  return jspb.Message.setProto3BooleanField(this, 208, value);
};


/**
 * optional bool rfd_controller_max_speed_parity = 209;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdControllerMaxSpeedParity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 209, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdControllerMaxSpeedParity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 209, value);
};


/**
 * optional bool enable_ar_street_overlays = 210;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableArStreetOverlays = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 210, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableArStreetOverlays = function(value) {
  return jspb.Message.setProto3BooleanField(this, 210, value);
};


/**
 * optional bool enable_rfd_hud_compass = 213;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdHudCompass = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 213, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdHudCompass = function(value) {
  return jspb.Message.setProto3BooleanField(this, 213, value);
};


/**
 * optional bool enable_rfd_hud_airspeed_altitude = 216;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdHudAirspeedAltitude = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 216, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdHudAirspeedAltitude = function(value) {
  return jspb.Message.setProto3BooleanField(this, 216, value);
};


/**
 * optional bool move_vehicle_launch_modal_video_feed = 220;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMoveVehicleLaunchModalVideoFeed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 220, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMoveVehicleLaunchModalVideoFeed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 220, value);
};


/**
 * optional bool enable_dock_transit_point = 222;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockTransitPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 222, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockTransitPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 222, value);
};


/**
 * optional bool use_pathfinder_fly_to_point_rfd = 227;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUsePathfinderFlyToPointRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 227, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUsePathfinderFlyToPointRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 227, value);
};


/**
 * optional bool media_available_for_flight_alert = 228;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMediaAvailableForFlightAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 228, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMediaAvailableForFlightAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 228, value);
};


/**
 * optional bool dfr_stock_settings = 232;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDfrStockSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 232, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDfrStockSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 232, value);
};


/**
 * optional bool customer_2_custom_mapbox_map_styles = 234;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomer2CustomMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 234, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomer2CustomMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 234, value);
};


/**
 * optional bool rfd_connectivity_settings_tab = 236;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdConnectivitySettingsTab = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 236, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdConnectivitySettingsTab = function(value) {
  return jspb.Message.setProto3BooleanField(this, 236, value);
};


/**
 * optional bool mission_editor_night_autonomy = 237;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorNightAutonomy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 237, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorNightAutonomy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 237, value);
};


/**
 * optional bool rfd_parachute_attachment_ui = 238;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdParachuteAttachmentUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 238, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdParachuteAttachmentUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 238, value);
};


/**
 * optional bool show_cloud_simulator_controls = 239;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowCloudSimulatorControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 239, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowCloudSimulatorControls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 239, value);
};


/**
 * optional bool mission_sharing_customer_portal = 240;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionSharingCustomerPortal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 240, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionSharingCustomerPortal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 240, value);
};


/**
 * optional bool use_improved_flight_status_workflow = 243;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseImprovedFlightStatusWorkflow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 243, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseImprovedFlightStatusWorkflow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 243, value);
};


/**
 * optional bool rfd_telemetry_stats = 247;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdTelemetryStats = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 247, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdTelemetryStats = function(value) {
  return jspb.Message.setProto3BooleanField(this, 247, value);
};


/**
 * optional bool show_operations_area_internal_mapbox_styles = 248;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOperationsAreaInternalMapboxStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 248, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOperationsAreaInternalMapboxStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 248, value);
};


/**
 * optional bool activate_strobe_lights_on_launch_rfd = 249;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getActivateStrobeLightsOnLaunchRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 249, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setActivateStrobeLightsOnLaunchRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 249, value);
};


/**
 * optional bool mission_documents_api = 250;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionDocumentsApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 250, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionDocumentsApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 250, value);
};


/**
 * optional bool fleet_page_sd_card_formatting = 251;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFleetPageSdCardFormatting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 251, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFleetPageSdCardFormatting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 251, value);
};


/**
 * optional bool enable_multidrone_operations = 252;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneOperations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 252, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneOperations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 252, value);
};


/**
 * optional bool control_key_drag_waypoint_vertical = 254;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getControlKeyDragWaypointVertical = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 254, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setControlKeyDragWaypointVertical = function(value) {
  return jspb.Message.setProto3BooleanField(this, 254, value);
};


/**
 * optional bool show_terrain_and_bldgs_toggle_in_fleet_page = 255;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowTerrainAndBldgsToggleInFleetPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 255, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowTerrainAndBldgsToggleInFleetPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 255, value);
};


/**
 * optional bool show_overlapping_dock_wifi_channels_fleet_page = 259;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowOverlappingDockWifiChannelsFleetPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 259, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowOverlappingDockWifiChannelsFleetPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 259, value);
};


/**
 * optional bool show_internal_mapbox_styles_3 = 261;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowInternalMapboxStyles3 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 261, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowInternalMapboxStyles3 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 261, value);
};


/**
 * optional bool fixed_location_rid = 262;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFixedLocationRid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 262, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFixedLocationRid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 262, value);
};


/**
 * optional bool teleop_pilot_keep_alive = 264;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTeleopPilotKeepAlive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 264, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTeleopPilotKeepAlive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 264, value);
};


/**
 * optional bool enable_rtk_support = 272;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRtkSupport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 272, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRtkSupport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 272, value);
};


/**
 * optional bool city_customer_mapbox_map_styles = 274;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCityCustomerMapboxMapStyles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 274, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCityCustomerMapboxMapStyles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 274, value);
};


/**
 * optional bool link_loss_alert_level_caution = 276;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getLinkLossAlertLevelCaution = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 276, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setLinkLossAlertLevelCaution = function(value) {
  return jspb.Message.setProto3BooleanField(this, 276, value);
};


/**
 * optional bool enable_setup_flights = 288;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSetupFlights = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 288, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSetupFlights = function(value) {
  return jspb.Message.setProto3BooleanField(this, 288, value);
};


/**
 * optional bool european_union = 289;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEuropeanUnion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 289, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEuropeanUnion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 289, value);
};


/**
 * optional bool enable_create_marker_interaction_rfd = 292;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCreateMarkerInteractionRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 292, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCreateMarkerInteractionRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 292, value);
};


/**
 * optional bool dronesense_integration_setup = 293;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDronesenseIntegrationSetup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 293, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDronesenseIntegrationSetup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 293, value);
};


/**
 * optional bool enable_c18_microhard_offline_configuration = 295;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableC18MicrohardOfflineConfiguration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 295, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableC18MicrohardOfflineConfiguration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 295, value);
};


/**
 * optional bool custom_map_layers_external = 296;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomMapLayersExternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 296, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomMapLayersExternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 296, value);
};


/**
 * optional bool custom_map_layers_internal = 297;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomMapLayersInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 297, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomMapLayersInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 297, value);
};


/**
 * optional bool filter_markers_in_rfd_sidebar = 303;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFilterMarkersInRfdSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 303, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFilterMarkersInRfdSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 303, value);
};


/**
 * optional bool dfr_command = 305;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDfrCommand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 305, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDfrCommand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 305, value);
};


/**
 * optional bool mission_details_above_skills_switcher = 306;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionDetailsAboveSkillsSwitcher = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 306, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionDetailsAboveSkillsSwitcher = function(value) {
  return jspb.Message.setProto3BooleanField(this, 306, value);
};


/**
 * optional bool multi_battery_missions = 307;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiBatteryMissions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 307, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiBatteryMissions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 307, value);
};


/**
 * optional bool swap_to_x10_dock_cam_on_landing = 308;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSwapToX10DockCamOnLanding = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 308, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSwapToX10DockCamOnLanding = function(value) {
  return jspb.Message.setProto3BooleanField(this, 308, value);
};


/**
 * optional bool enable_rfd_dedrone = 310;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdDedrone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 310, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdDedrone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 310, value);
};


/**
 * optional bool enable_rfd_adsb_recording = 311;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdAdsbRecording = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 311, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdAdsbRecording = function(value) {
  return jspb.Message.setProto3BooleanField(this, 311, value);
};


/**
 * optional bool mission_editor_show_internal_navigation_mode_options = 313;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorShowInternalNavigationModeOptions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 313, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorShowInternalNavigationModeOptions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 313, value);
};


/**
 * optional bool enable_dfr_command_phase_two_ui = 314;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseTwoUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 314, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseTwoUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 314, value);
};


/**
 * optional bool enable_dfr_command_phase_two_point_five_ui = 315;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseTwoPointFiveUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 315, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseTwoPointFiveUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 315, value);
};


/**
 * optional bool enable_dfr_command_phase_three_ui = 316;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrCommandPhaseThreeUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 316, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrCommandPhaseThreeUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 316, value);
};


/**
 * optional bool enable_dfr_org_based_livekit_room = 317;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrOrgBasedLivekitRoom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 317, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrOrgBasedLivekitRoom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 317, value);
};


/**
 * optional bool x10_defaults_for_gps_init_waypoint = 318;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getX10DefaultsForGpsInitWaypoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 318, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setX10DefaultsForGpsInitWaypoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 318, value);
};


/**
 * optional bool enable_proper_ar_sync = 324;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableProperArSync = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 324, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableProperArSync = function(value) {
  return jspb.Message.setProto3BooleanField(this, 324, value);
};


/**
 * optional bool enable_rfd_view_lookat_point = 329;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdViewLookatPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 329, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdViewLookatPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 329, value);
};


/**
 * optional bool enable_rfd_set_lookat_point = 330;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdSetLookatPoint = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 330, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdSetLookatPoint = function(value) {
  return jspb.Message.setProto3BooleanField(this, 330, value);
};


/**
 * optional bool simulate_remote_on_prem_org = 333;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSimulateRemoteOnPremOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 333, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSimulateRemoteOnPremOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 333, value);
};


/**
 * optional bool multi_org_users_rpic = 337;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultiOrgUsersRpic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 337, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultiOrgUsersRpic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 337, value);
};


/**
 * optional bool markers_api = 339;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMarkersApi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 339, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMarkersApi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 339, value);
};


/**
 * optional bool allow_direct_device_adoption = 342;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowDirectDeviceAdoption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 342, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowDirectDeviceAdoption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 342, value);
};


/**
 * optional bool enable_dockless_sites = 343;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDocklessSites = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 343, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDocklessSites = function(value) {
  return jspb.Message.setProto3BooleanField(this, 343, value);
};


/**
 * optional bool enable_teleop_in_iframe = 347;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableTeleopInIframe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 347, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableTeleopInIframe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 347, value);
};


/**
 * optional bool enable_dfr_dockview_layout = 348;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrDockviewLayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 348, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrDockviewLayout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 348, value);
};


/**
 * optional bool enable_customer_managed_session_lengths = 349;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCustomerManagedSessionLengths = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 349, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCustomerManagedSessionLengths = function(value) {
  return jspb.Message.setProto3BooleanField(this, 349, value);
};


/**
 * optional bool enable_dispatch_respond_here = 352;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDispatchRespondHere = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 352, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDispatchRespondHere = function(value) {
  return jspb.Message.setProto3BooleanField(this, 352, value);
};


/**
 * optional bool deployment_engineer_missions_internal = 355;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDeploymentEngineerMissionsInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 355, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDeploymentEngineerMissionsInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 355, value);
};


/**
 * optional bool set_take_photo_wait_for_focus_to_converge = 357;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSetTakePhotoWaitForFocusToConverge = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 357, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSetTakePhotoWaitForFocusToConverge = function(value) {
  return jspb.Message.setProto3BooleanField(this, 357, value);
};


/**
 * optional bool enable_validation_of_on_demand_mission = 360;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableValidationOfOnDemandMission = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 360, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableValidationOfOnDemandMission = function(value) {
  return jspb.Message.setProto3BooleanField(this, 360, value);
};


/**
 * optional bool enable_axon_watch_me_demo = 361;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAxonWatchMeDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 361, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAxonWatchMeDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 361, value);
};


/**
 * optional bool enable_incidents_state_ui = 363;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableIncidentsStateUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 363, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableIncidentsStateUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 363, value);
};


/**
 * optional bool enable_planning_around_geofences_fly_to_point_rfd = 364;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePlanningAroundGeofencesFlyToPointRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 364, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePlanningAroundGeofencesFlyToPointRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 364, value);
};


/**
 * optional bool hive_channel_conflict_prevention = 368;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHiveChannelConflictPrevention = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 368, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHiveChannelConflictPrevention = function(value) {
  return jspb.Message.setProto3BooleanField(this, 368, value);
};


/**
 * optional bool unified_mission_editor = 370;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUnifiedMissionEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 370, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUnifiedMissionEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 370, value);
};


/**
 * optional bool missions_cloud_to_controller = 371;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionsCloudToController = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 371, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionsCloudToController = function(value) {
  return jspb.Message.setProto3BooleanField(this, 371, value);
};


/**
 * optional bool enable_waypoint_metrics_workflow = 372;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableWaypointMetricsWorkflow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 372, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableWaypointMetricsWorkflow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 372, value);
};


/**
 * optional bool enable_propeller_type_specification = 373;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePropellerTypeSpecification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 373, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePropellerTypeSpecification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 373, value);
};


/**
 * optional bool improved_landing_buttons = 374;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getImprovedLandingButtons = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 374, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setImprovedLandingButtons = function(value) {
  return jspb.Message.setProto3BooleanField(this, 374, value);
};


/**
 * optional bool enable_cancel_incident_response_modal = 376;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCancelIncidentResponseModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 376, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCancelIncidentResponseModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 376, value);
};


/**
 * optional bool display_cellular_carrier_info = 378;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisplayCellularCarrierInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 378, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisplayCellularCarrierInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 378, value);
};


/**
 * optional bool enable_unsupported_browser_warning = 379;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableUnsupportedBrowserWarning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 379, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableUnsupportedBrowserWarning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 379, value);
};


/**
 * optional bool enable_extra_access_modes = 380;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableExtraAccessModes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 380, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableExtraAccessModes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 380, value);
};


/**
 * optional bool enable_custom_map_layers_backend = 381;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCustomMapLayersBackend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 381, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCustomMapLayersBackend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 381, value);
};


/**
 * optional bool reverse_geocode_markers_on_read = 383;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReverseGeocodeMarkersOnRead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 383, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReverseGeocodeMarkersOnRead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 383, value);
};


/**
 * optional bool edit_org_flight_policy_nondocked = 385;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgFlightPolicyNondocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 385, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgFlightPolicyNondocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 385, value);
};


/**
 * optional bool sites_improvements_5_25 = 387;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSitesImprovements525 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 387, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSitesImprovements525 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 387, value);
};


/**
 * optional bool cloud_rel_5_ui_updates = 388;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel5UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 388, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel5UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 388, value);
};


/**
 * optional bool show_file_release_ui = 389;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowFileReleaseUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 389, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowFileReleaseUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 389, value);
};


/**
 * optional bool use_x10rev1_and_unknown_accelerated_prop_wear_alert = 390;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseX10rev1AndUnknownAcceleratedPropWearAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 390, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseX10rev1AndUnknownAcceleratedPropWearAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 390, value);
};


/**
 * optional bool use_x10rev2_accelerated_prop_wear_alert = 391;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseX10rev2AcceleratedPropWearAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 391, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseX10rev2AcceleratedPropWearAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 391, value);
};


/**
 * optional bool rtk_early_access_program = 392;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRtkEarlyAccessProgram = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 392, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRtkEarlyAccessProgram = function(value) {
  return jspb.Message.setProto3BooleanField(this, 392, value);
};


/**
 * optional bool new_cloud_navigation = 393;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNewCloudNavigation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 393, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNewCloudNavigation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 393, value);
};


/**
 * optional bool api_observability = 394;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getApiObservability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 394, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setApiObservability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 394, value);
};


/**
 * optional bool new_integrations_ui = 395;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNewIntegrationsUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 395, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNewIntegrationsUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 395, value);
};


/**
 * optional bool updated_create_organization_modal = 397;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUpdatedCreateOrganizationModal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 397, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUpdatedCreateOrganizationModal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 397, value);
};


/**
 * optional bool cloud_sim_automatic_site_setup = 398;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudSimAutomaticSiteSetup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 398, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudSimAutomaticSiteSetup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 398, value);
};


/**
 * optional bool enable_post_flight_reports = 402;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePostFlightReports = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 402, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePostFlightReports = function(value) {
  return jspb.Message.setProto3BooleanField(this, 402, value);
};


/**
 * optional bool enable_dfr_outcomes_survey = 406;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDfrOutcomesSurvey = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 406, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDfrOutcomesSurvey = function(value) {
  return jspb.Message.setProto3BooleanField(this, 406, value);
};


/**
 * optional bool rfd_streamline_notifications = 407;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdStreamlineNotifications = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 407, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdStreamlineNotifications = function(value) {
  return jspb.Message.setProto3BooleanField(this, 407, value);
};


/**
 * optional bool enable_battery_fretting_alerts = 409;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableBatteryFrettingAlerts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 409, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableBatteryFrettingAlerts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 409, value);
};


/**
 * optional bool include_case_ids_in_axon_evidence_title = 411;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIncludeCaseIdsInAxonEvidenceTitle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 411, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIncludeCaseIdsInAxonEvidenceTitle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 411, value);
};


/**
 * optional bool show_internal_flight_deck_commands = 412;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowInternalFlightDeckCommands = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 412, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowInternalFlightDeckCommands = function(value) {
  return jspb.Message.setProto3BooleanField(this, 412, value);
};


/**
 * optional bool disable_email_logins = 416;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisableEmailLogins = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 416, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisableEmailLogins = function(value) {
  return jspb.Message.setProto3BooleanField(this, 416, value);
};


/**
 * optional bool multiple_media_sync_policies = 420;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMultipleMediaSyncPolicies = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 420, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMultipleMediaSyncPolicies = function(value) {
  return jspb.Message.setProto3BooleanField(this, 420, value);
};


/**
 * optional bool show_a22_details_in_ui = 422;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowA22DetailsInUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 422, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowA22DetailsInUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 422, value);
};


/**
 * optional bool subject_tracking = 424;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSubjectTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 424, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSubjectTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 424, value);
};


/**
 * optional bool asset_inspection_mission_planning_v0 = 425;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAssetInspectionMissionPlanningV0 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 425, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAssetInspectionMissionPlanningV0 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 425, value);
};


/**
 * optional bool enable_pre_flight_checklists = 426;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePreFlightChecklists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 426, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePreFlightChecklists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 426, value);
};


/**
 * optional bool branding_dfr_command = 427;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBrandingDfrCommand = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 427, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBrandingDfrCommand = function(value) {
  return jspb.Message.setProto3BooleanField(this, 427, value);
};


/**
 * optional bool enable_surface_scan_skill_teleop = 429;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSurfaceScanSkillTeleop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 429, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSurfaceScanSkillTeleop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 429, value);
};


/**
 * optional bool autonomy_widget_rfd = 430;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutonomyWidgetRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 430, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutonomyWidgetRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 430, value);
};


/**
 * optional bool show_propeller_hours_tracking_override_setting = 431;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowPropellerHoursTrackingOverrideSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 431, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowPropellerHoursTrackingOverrideSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 431, value);
};


/**
 * optional bool dock_compute_replacement = 432;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDockComputeReplacement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 432, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDockComputeReplacement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 432, value);
};


/**
 * optional bool allow_scan_plane_offset_for_map_capture = 435;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowScanPlaneOffsetForMapCapture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 435, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowScanPlaneOffsetForMapCapture = function(value) {
  return jspb.Message.setProto3BooleanField(this, 435, value);
};


/**
 * optional bool rtk_ppk_rfd_telemetry = 436;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRtkPpkRfdTelemetry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 436, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRtkPpkRfdTelemetry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 436, value);
};


/**
 * optional bool subject_tracking_for_engineering = 437;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSubjectTrackingForEngineering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 437, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSubjectTrackingForEngineering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 437, value);
};


/**
 * optional bool enable_multidrone_ascend_fy26 = 440;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneAscendFy26 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 440, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneAscendFy26 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 440, value);
};


/**
 * optional bool cloud_sim_recreate_experience = 444;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudSimRecreateExperience = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 444, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudSimRecreateExperience = function(value) {
  return jspb.Message.setProto3BooleanField(this, 444, value);
};


/**
 * optional bool onprem_management_organization = 446;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOnpremManagementOrganization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 446, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOnpremManagementOrganization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 446, value);
};


/**
 * optional bool show_adaptive_capture_settings_ui = 448;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAdaptiveCaptureSettingsUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 448, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAdaptiveCaptureSettingsUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 448, value);
};


/**
 * optional bool enable_flight_system_reboot_scheduler = 449;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFlightSystemRebootScheduler = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 449, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFlightSystemRebootScheduler = function(value) {
  return jspb.Message.setProto3BooleanField(this, 449, value);
};


/**
 * optional bool enable_cloud_sim_tailscale = 450;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCloudSimTailscale = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 450, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCloudSimTailscale = function(value) {
  return jspb.Message.setProto3BooleanField(this, 450, value);
};


/**
 * optional bool get_permission_from_sim_team_first_enable_r71_cloud_simulator = 451;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGetPermissionFromSimTeamFirstEnableR71CloudSimulator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 451, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGetPermissionFromSimTeamFirstEnableR71CloudSimulator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 451, value);
};


/**
 * optional bool edit_org_capture_settings_nondocked = 452;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgCaptureSettingsNondocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 452, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgCaptureSettingsNondocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 452, value);
};


/**
 * optional bool render_backend_scan_plan = 453;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRenderBackendScanPlan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 453, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRenderBackendScanPlan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 453, value);
};


/**
 * optional bool enable_cloud_driven_encryption = 454;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCloudDrivenEncryption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 454, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCloudDrivenEncryption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 454, value);
};


/**
 * optional bool mission_device_switching = 455;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionDeviceSwitching = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 455, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionDeviceSwitching = function(value) {
  return jspb.Message.setProto3BooleanField(this, 455, value);
};


/**
 * optional bool asset_settings_view = 456;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAssetSettingsView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 456, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAssetSettingsView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 456, value);
};


/**
 * optional bool cloud_sim_show_2025_ascend_versions = 457;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudSimShow2025AscendVersions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 457, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudSimShow2025AscendVersions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 457, value);
};


/**
 * optional bool mission_settings_flight_policy_v0 = 458;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionSettingsFlightPolicyV0 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 458, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionSettingsFlightPolicyV0 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 458, value);
};


/**
 * optional bool api_portal_download_parity = 459;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getApiPortalDownloadParity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 459, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setApiPortalDownloadParity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 459, value);
};


/**
 * optional bool geofence_aware_mission_planning = 460;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGeofenceAwareMissionPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 460, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGeofenceAwareMissionPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 460, value);
};


/**
 * optional bool inm_ascend_fy26 = 461;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getInmAscendFy26 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 461, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setInmAscendFy26 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 461, value);
};


/**
 * optional bool apply_c18_irq_storm_cloud_overrides_to_org = 462;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getApplyC18IrqStormCloudOverridesToOrg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 462, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setApplyC18IrqStormCloudOverridesToOrg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 462, value);
};


/**
 * optional bool agl_from_vehicle_rfd = 463;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAglFromVehicleRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 463, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAglFromVehicleRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 463, value);
};


/**
 * optional bool stop_sending_auto_record_true_from_rfd = 464;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getStopSendingAutoRecordTrueFromRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 464, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setStopSendingAutoRecordTrueFromRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 464, value);
};


/**
 * optional bool use_device_software_compatibility_matrix = 465;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseDeviceSoftwareCompatibilityMatrix = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 465, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseDeviceSoftwareCompatibilityMatrix = function(value) {
  return jspb.Message.setProto3BooleanField(this, 465, value);
};


/**
 * optional bool rfd_early_prep = 466;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdEarlyPrep = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 466, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdEarlyPrep = function(value) {
  return jspb.Message.setProto3BooleanField(this, 466, value);
};


/**
 * optional bool rfd_pathfinder_disables_nightsense = 467;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdPathfinderDisablesNightsense = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 467, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdPathfinderDisablesNightsense = function(value) {
  return jspb.Message.setProto3BooleanField(this, 467, value);
};


/**
 * optional bool axon_alpr_integration = 468;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAxonAlprIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 468, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAxonAlprIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 468, value);
};


/**
 * optional bool enable_compute_mission_trajectory = 469;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableComputeMissionTrajectory = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 469, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableComputeMissionTrajectory = function(value) {
  return jspb.Message.setProto3BooleanField(this, 469, value);
};


/**
 * optional bool enable_1hz_dispatch_telemetry_downsampling = 470;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnable1hzDispatchTelemetryDownsampling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 470, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnable1hzDispatchTelemetryDownsampling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 470, value);
};


/**
 * optional bool show_bitrate_preset_in_flight_policy = 471;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowBitratePresetInFlightPolicy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 471, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowBitratePresetInFlightPolicy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 471, value);
};


/**
 * optional bool hide_safe_landing_if_none_set = 472;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHideSafeLandingIfNoneSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 472, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHideSafeLandingIfNoneSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 472, value);
};


/**
 * optional bool mission_editor_height_frame_selector = 474;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorHeightFrameSelector = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 474, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorHeightFrameSelector = function(value) {
  return jspb.Message.setProto3BooleanField(this, 474, value);
};


/**
 * optional bool fusus_cad_integration = 475;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFususCadIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 475, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFususCadIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 475, value);
};


/**
 * optional bool enable_alert_text = 476;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAlertText = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 476, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAlertText = function(value) {
  return jspb.Message.setProto3BooleanField(this, 476, value);
};


/**
 * optional bool mpeg_ts_settings = 477;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMpegTsSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 477, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMpegTsSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 477, value);
};


/**
 * optional bool expose_org_tier = 478;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getExposeOrgTier = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 478, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setExposeOrgTier = function(value) {
  return jspb.Message.setProto3BooleanField(this, 478, value);
};


/**
 * optional bool undo_upsert_marker_optimization = 480;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUndoUpsertMarkerOptimization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 480, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUndoUpsertMarkerOptimization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 480, value);
};


/**
 * optional bool nomad_maps_mission_editor = 481;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNomadMapsMissionEditor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 481, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNomadMapsMissionEditor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 481, value);
};


/**
 * optional bool unified_post_mission_actions = 482;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUnifiedPostMissionActions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 482, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUnifiedPostMissionActions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 482, value);
};


/**
 * optional bool hardware_key_encryption_enabled = 484;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHardwareKeyEncryptionEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 484, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHardwareKeyEncryptionEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 484, value);
};


/**
 * optional bool write_address_for_bodycams = 485;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getWriteAddressForBodycams = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 485, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setWriteAddressForBodycams = function(value) {
  return jspb.Message.setProto3BooleanField(this, 485, value);
};


/**
 * optional bool dedrone_integration = 486;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDedroneIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 486, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDedroneIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 486, value);
};


/**
 * optional bool enable_video_feedback_survey = 487;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableVideoFeedbackSurvey = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 487, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableVideoFeedbackSurvey = function(value) {
  return jspb.Message.setProto3BooleanField(this, 487, value);
};


/**
 * optional bool paraverse_arcade_post_flight_form = 488;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getParaverseArcadePostFlightForm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 488, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setParaverseArcadePostFlightForm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 488, value);
};


/**
 * optional bool enable_multidrone_rfd = 489;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 489, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 489, value);
};


/**
 * optional bool allow_dockless_live_mission_planning = 490;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAllowDocklessLiveMissionPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 490, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAllowDocklessLiveMissionPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 490, value);
};


/**
 * optional bool ar_sync_in_worker = 491;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getArSyncInWorker = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 491, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setArSyncInWorker = function(value) {
  return jspb.Message.setProto3BooleanField(this, 491, value);
};


/**
 * optional bool rfd_enable_drone_dock_name = 492;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdEnableDroneDockName = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 492, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdEnableDroneDockName = function(value) {
  return jspb.Message.setProto3BooleanField(this, 492, value);
};


/**
 * optional bool hive_acs = 493;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHiveAcs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 493, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHiveAcs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 493, value);
};


/**
 * optional bool controller_support_cloud_encryption = 494;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getControllerSupportCloudEncryption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 494, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setControllerSupportCloudEncryption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 494, value);
};


/**
 * optional bool extend_geofence_vertex_limit = 495;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getExtendGeofenceVertexLimit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 495, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setExtendGeofenceVertexLimit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 495, value);
};


/**
 * optional bool skills_selector_in_autonomy_widget = 496;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSkillsSelectorInAutonomyWidget = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 496, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSkillsSelectorInAutonomyWidget = function(value) {
  return jspb.Message.setProto3BooleanField(this, 496, value);
};


/**
 * optional bool react_perf_fixes = 497;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReactPerfFixes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 497, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReactPerfFixes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 497, value);
};


/**
 * optional bool pathfinder_boundaries_menu = 499;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPathfinderBoundariesMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 499, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPathfinderBoundariesMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 499, value);
};


/**
 * optional bool rfd_higher_max_speed = 500;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdHigherMaxSpeed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 500, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdHigherMaxSpeed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 500, value);
};


/**
 * optional bool cad_id_syncing = 501;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCadIdSyncing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 501, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCadIdSyncing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 501, value);
};


/**
 * optional bool clear_markers_dispatch_map = 502;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getClearMarkersDispatchMap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 502, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setClearMarkersDispatchMap = function(value) {
  return jspb.Message.setProto3BooleanField(this, 502, value);
};


/**
 * optional bool rfd_primary_altitude_setting = 504;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdPrimaryAltitudeSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 504, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdPrimaryAltitudeSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 504, value);
};


/**
 * optional bool gen_2_g47_charger_eap = 507;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGen2G47ChargerEap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 507, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGen2G47ChargerEap = function(value) {
  return jspb.Message.setProto3BooleanField(this, 507, value);
};


/**
 * optional bool enable_sentry_autodetection = 508;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableSentryAutodetection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 508, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableSentryAutodetection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 508, value);
};


/**
 * optional bool fix_livestream_mutation = 509;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFixLivestreamMutation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 509, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFixLivestreamMutation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 509, value);
};


/**
 * optional bool markers_backend_filtering = 511;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMarkersBackendFiltering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 511, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMarkersBackendFiltering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 511, value);
};


/**
 * optional bool suppress_air_traffic_alerts_when_grounded = 512;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSuppressAirTrafficAlertsWhenGrounded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 512, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSuppressAirTrafficAlertsWhenGrounded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 512, value);
};


/**
 * optional bool rfd_on_subdomain = 513;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdOnSubdomain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 513, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdOnSubdomain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 513, value);
};


/**
 * optional bool fleet_map_view_enhancements = 514;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFleetMapViewEnhancements = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 514, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFleetMapViewEnhancements = function(value) {
  return jspb.Message.setProto3BooleanField(this, 514, value);
};


/**
 * optional bool consumables_usage_alerts = 1812;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getConsumablesUsageAlerts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1812, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setConsumablesUsageAlerts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1812, value);
};


/**
 * optional bool single_click_ota_extended = 9001;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSingleClickOtaExtended = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9001, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSingleClickOtaExtended = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9001, value);
};


/**
 * optional bool cloud_rel_13_ui_updates = 518;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel13UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 518, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel13UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 518, value);
};


/**
 * optional bool atlas_points_rfd_v2 = 520;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAtlasPointsRfdV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 520, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAtlasPointsRfdV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 520, value);
};


/**
 * optional bool missions_in_rfd_v2 = 521;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionsInRfdV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 521, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionsInRfdV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 521, value);
};


/**
 * optional bool mission_resumability = 522;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionResumability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 522, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionResumability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 522, value);
};


/**
 * optional bool playwright_blank_map_rendering = 523;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPlaywrightBlankMapRendering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 523, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPlaywrightBlankMapRendering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 523, value);
};


/**
 * optional bool cloud_rel_cayley_ui_updates = 524;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRelCayleyUiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 524, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRelCayleyUiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 524, value);
};


/**
 * optional bool enable_rfdv2_sidebar_layout = 525;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdv2SidebarLayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 525, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdv2SidebarLayout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 525, value);
};


/**
 * optional bool enable_pathfinder_boundary_management = 526;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePathfinderBoundaryManagement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 526, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePathfinderBoundaryManagement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 526, value);
};


/**
 * optional bool show_device_factory_reset_ui = 527;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowDeviceFactoryResetUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 527, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowDeviceFactoryResetUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 527, value);
};


/**
 * optional bool show_product_improvement_consent_toggle = 528;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowProductImprovementConsentToggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 528, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowProductImprovementConsentToggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 528, value);
};


/**
 * optional bool enable_paraverse_arcade_creation = 529;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableParaverseArcadeCreation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 529, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableParaverseArcadeCreation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 529, value);
};


/**
 * optional bool nomad_true_orthographic_mode = 530;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getNomadTrueOrthographicMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 530, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setNomadTrueOrthographicMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 530, value);
};


/**
 * optional bool content_hint_motion = 532;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getContentHintMotion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 532, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setContentHintMotion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 532, value);
};


/**
 * optional bool manage_adsb_alert_settings_with_org_override = 533;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getManageAdsbAlertSettingsWithOrgOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 533, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setManageAdsbAlertSettingsWithOrgOverride = function(value) {
  return jspb.Message.setProto3BooleanField(this, 533, value);
};


/**
 * optional bool enable_agl_geofences = 534;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAglGeofences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 534, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAglGeofences = function(value) {
  return jspb.Message.setProto3BooleanField(this, 534, value);
};


/**
 * optional bool enable_rfdv2_sidebar_stack = 535;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdv2SidebarStack = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 535, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdv2SidebarStack = function(value) {
  return jspb.Message.setProto3BooleanField(this, 535, value);
};


/**
 * optional bool fetch_recording_bodycams_only = 536;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFetchRecordingBodycamsOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 536, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFetchRecordingBodycamsOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 536, value);
};


/**
 * optional bool zero_latency_controls = 537;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getZeroLatencyControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 537, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setZeroLatencyControls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 537, value);
};


/**
 * optional bool enable_viewer_count_from_redis = 538;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableViewerCountFromRedis = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 538, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableViewerCountFromRedis = function(value) {
  return jspb.Message.setProto3BooleanField(this, 538, value);
};


/**
 * optional bool atlas_points_rfd_v2_markers_only = 539;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAtlasPointsRfdV2MarkersOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 539, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAtlasPointsRfdV2MarkersOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 539, value);
};


/**
 * optional bool rfd_on_subdomain_for_engineering = 540;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdOnSubdomainForEngineering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 540, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdOnSubdomainForEngineering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 540, value);
};


/**
 * optional bool gamepad_subject_tracking = 541;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getGamepadSubjectTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 541, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setGamepadSubjectTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 541, value);
};


/**
 * optional bool filter_by_health_status = 542;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFilterByHealthStatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 542, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFilterByHealthStatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 542, value);
};


/**
 * optional bool flat_list_of_health_issues = 543;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFlatListOfHealthIssues = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 543, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFlatListOfHealthIssues = function(value) {
  return jspb.Message.setProto3BooleanField(this, 543, value);
};


/**
 * optional bool integrate_kml_importer_into_mission_planning = 544;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIntegrateKmlImporterIntoMissionPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 544, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIntegrateKmlImporterIntoMissionPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 544, value);
};


/**
 * optional bool shotspotter_integration = 546;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShotspotterIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 546, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShotspotterIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 546, value);
};


/**
 * optional bool enable_rfd_v2_coming_soon_banner = 547;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRfdV2ComingSoonBanner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 547, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRfdV2ComingSoonBanner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 547, value);
};


/**
 * optional bool enable_file_auto_retention_and_soft_delete = 548;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFileAutoRetentionAndSoftDelete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 548, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFileAutoRetentionAndSoftDelete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 548, value);
};


/**
 * optional bool split_user_media_upload_progress = 549;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSplitUserMediaUploadProgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 549, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSplitUserMediaUploadProgress = function(value) {
  return jspb.Message.setProto3BooleanField(this, 549, value);
};


/**
 * optional bool enable_cloud_tak_markers = 550;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCloudTakMarkers = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 550, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCloudTakMarkers = function(value) {
  return jspb.Message.setProto3BooleanField(this, 550, value);
};


/**
 * optional bool flight_system_view_redesign = 551;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFlightSystemViewRedesign = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 551, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFlightSystemViewRedesign = function(value) {
  return jspb.Message.setProto3BooleanField(this, 551, value);
};


/**
 * optional bool sites_geofence_import_export = 552;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSitesGeofenceImportExport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 552, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSitesGeofenceImportExport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 552, value);
};


/**
 * optional bool enable_markers_gql_federation = 553;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMarkersGqlFederation = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 553, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMarkersGqlFederation = function(value) {
  return jspb.Message.setProto3BooleanField(this, 553, value);
};


/**
 * optional bool asset_survey_from_photos = 554;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAssetSurveyFromPhotos = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 554, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAssetSurveyFromPhotos = function(value) {
  return jspb.Message.setProto3BooleanField(this, 554, value);
};


/**
 * optional bool flight_details_page = 555;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFlightDetailsPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 555, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFlightDetailsPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 555, value);
};


/**
 * optional bool debounce_live_stream_alert = 556;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDebounceLiveStreamAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 556, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDebounceLiveStreamAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 556, value);
};


/**
 * optional bool enable_rtic_mode = 557;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableRticMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 557, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableRticMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 557, value);
};


/**
 * optional bool enable_declarative_dockview = 558;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDeclarativeDockview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 558, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDeclarativeDockview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 558, value);
};


/**
 * optional bool enable_custom_rfd_url = 559;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCustomRfdUrl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 559, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCustomRfdUrl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 559, value);
};


/**
 * optional bool enable_flight_path_visualization = 560;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableFlightPathVisualization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 560, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableFlightPathVisualization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 560, value);
};


/**
 * optional bool enable_view_salesforce_support_cases = 561;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableViewSalesforceSupportCases = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 561, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableViewSalesforceSupportCases = function(value) {
  return jspb.Message.setProto3BooleanField(this, 561, value);
};


/**
 * optional bool consumables_report = 562;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getConsumablesReport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 562, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setConsumablesReport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 562, value);
};


/**
 * optional bool faster_ttl = 563;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFasterTtl = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 563, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFasterTtl = function(value) {
  return jspb.Message.setProto3BooleanField(this, 563, value);
};


/**
 * optional bool enable_planned_operations = 564;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePlannedOperations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 564, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePlannedOperations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 564, value);
};


/**
 * optional bool enable_docked_rth_deconfliction = 565;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockedRthDeconfliction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 565, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockedRthDeconfliction = function(value) {
  return jspb.Message.setProto3BooleanField(this, 565, value);
};


/**
 * optional bool enable_historical_marker_filters = 566;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableHistoricalMarkerFilters = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 566, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableHistoricalMarkerFilters = function(value) {
  return jspb.Message.setProto3BooleanField(this, 566, value);
};


/**
 * optional bool enable_operations_v0 = 567;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableOperationsV0 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 567, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableOperationsV0 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 567, value);
};


/**
 * optional bool mission_running = 568;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionRunning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 568, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionRunning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 568, value);
};


/**
 * optional bool show_file_auto_deletion_ux = 569;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowFileAutoDeletionUx = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 569, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowFileAutoDeletionUx = function(value) {
  return jspb.Message.setProto3BooleanField(this, 569, value);
};


/**
 * optional bool integration_ui_improvements = 570;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getIntegrationUiImprovements = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 570, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setIntegrationUiImprovements = function(value) {
  return jspb.Message.setProto3BooleanField(this, 570, value);
};


/**
 * optional bool better_support_log_upload = 571;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getBetterSupportLogUpload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 571, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setBetterSupportLogUpload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 571, value);
};


/**
 * optional bool frontend_beta = 572;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFrontendBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 572, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFrontendBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 572, value);
};


/**
 * optional bool show_last_pilot_flown = 573;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowLastPilotFlown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 573, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowLastPilotFlown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 573, value);
};


/**
 * optional bool display_theme_settings_view = 574;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisplayThemeSettingsView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 574, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisplayThemeSettingsView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 574, value);
};


/**
 * optional bool pilot_detail_page = 575;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPilotDetailPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 575, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPilotDetailPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 575, value);
};


/**
 * optional bool enable_north_indicator = 576;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableNorthIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 576, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableNorthIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 576, value);
};


/**
 * optional bool health_status_changed_alert = 577;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getHealthStatusChangedAlert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 577, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setHealthStatusChangedAlert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 577, value);
};


/**
 * optional bool rfd_collapsible_sidebar = 579;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdCollapsibleSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 579, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdCollapsibleSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 579, value);
};


/**
 * optional bool rfd_pinnable_sidebar = 580;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdPinnableSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 580, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdPinnableSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 580, value);
};


/**
 * optional bool enable_agl_height_ceiling = 578;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAglHeightCeiling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 578, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAglHeightCeiling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 578, value);
};


/**
 * optional bool display_pathfinder_boundaries_in_maps = 581;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getDisplayPathfinderBoundariesInMaps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 581, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setDisplayPathfinderBoundariesInMaps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 581, value);
};


/**
 * optional bool org_region_transfer = 582;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOrgRegionTransfer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 582, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOrgRegionTransfer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 582, value);
};


/**
 * optional bool show_parachute_required_setting = 583;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowParachuteRequiredSetting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 583, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowParachuteRequiredSetting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 583, value);
};


/**
 * optional bool cloud_rtk_profiles = 584;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRtkProfiles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 584, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRtkProfiles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 584, value);
};


/**
 * optional bool rfd_cockpit_v2 = 585;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdCockpitV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 585, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdCockpitV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 585, value);
};


/**
 * optional bool show_audit_events = 586;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAuditEvents = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 586, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAuditEvents = function(value) {
  return jspb.Message.setProto3BooleanField(this, 586, value);
};


/**
 * optional bool override_motion_api_to_legacy = 587;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOverrideMotionApiToLegacy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 587, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOverrideMotionApiToLegacy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 587, value);
};


/**
 * optional bool rfd_3d_cockpit = 588;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfd3dCockpit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 588, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfd3dCockpit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 588, value);
};


/**
 * optional bool pilot_leaderboard = 589;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPilotLeaderboard = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 589, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPilotLeaderboard = function(value) {
  return jspb.Message.setProto3BooleanField(this, 589, value);
};


/**
 * optional bool custom_map_layers_from_cloud = 590;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCustomMapLayersFromCloud = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 590, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCustomMapLayersFromCloud = function(value) {
  return jspb.Message.setProto3BooleanField(this, 590, value);
};


/**
 * optional bool enable_agl_waypoint_altitudes_rfd = 591;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAglWaypointAltitudesRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 591, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAglWaypointAltitudesRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 591, value);
};


/**
 * optional bool complete_stacknav_sidebar = 592;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCompleteStacknavSidebar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 592, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCompleteStacknavSidebar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 592, value);
};


/**
 * optional bool enable_multicockpit_rfd = 593;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMulticockpitRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 593, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMulticockpitRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 593, value);
};


/**
 * optional bool tak_integration = 594;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTakIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 594, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTakIntegration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 594, value);
};


/**
 * optional bool enable_toggling_geofences_rfd = 595;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableTogglingGeofencesRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 595, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableTogglingGeofencesRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 595, value);
};


/**
 * optional bool reliable_commandeering = 596;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getReliableCommandeering = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 596, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setReliableCommandeering = function(value) {
  return jspb.Message.setProto3BooleanField(this, 596, value);
};


/**
 * optional bool enable_marker_filter_settings = 597;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMarkerFilterSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 597, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMarkerFilterSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 597, value);
};


/**
 * optional bool rfd_launch_when_ready = 598;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdLaunchWhenReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 598, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdLaunchWhenReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 598, value);
};


/**
 * optional bool enable_cloud_ntrip = 599;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableCloudNtrip = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 599, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableCloudNtrip = function(value) {
  return jspb.Message.setProto3BooleanField(this, 599, value);
};


/**
 * optional bool enable_academy_online_code = 600;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAcademyOnlineCode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 600, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAcademyOnlineCode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 600, value);
};


/**
 * optional bool evidence_via_go = 601;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEvidenceViaGo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 601, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEvidenceViaGo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 601, value);
};


/**
 * optional bool enable_multidrone_adsb_rfd = 602;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultidroneAdsbRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 602, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultidroneAdsbRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 602, value);
};


/**
 * optional bool warning_enforcement_mode = 603;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getWarningEnforcementMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 603, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setWarningEnforcementMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 603, value);
};


/**
 * optional bool waypoint_drag_reorder = 604;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getWaypointDragReorder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 604, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setWaypointDragReorder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 604, value);
};


/**
 * optional bool ai_agent_rfd = 605;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAiAgentRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 605, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAiAgentRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 605, value);
};


/**
 * optional bool cloud_rel_14_ui_updates = 606;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRel14UiUpdates = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 606, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRel14UiUpdates = function(value) {
  return jspb.Message.setProto3BooleanField(this, 606, value);
};


/**
 * optional bool use_adsb_regulatory_manager_info = 607;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseAdsbRegulatoryManagerInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 607, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseAdsbRegulatoryManagerInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 607, value);
};


/**
 * optional bool enable_adsb_regulatory_manager_settings = 608;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableAdsbRegulatoryManagerSettings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 608, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableAdsbRegulatoryManagerSettings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 608, value);
};


/**
 * optional bool edit_org_flight_policy_r10 = 609;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEditOrgFlightPolicyR10 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 609, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEditOrgFlightPolicyR10 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 609, value);
};


/**
 * optional bool offline_portal = 610;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getOfflinePortal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 610, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setOfflinePortal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 610, value);
};


/**
 * optional bool rfd_disable_data_throttle = 611;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdDisableDataThrottle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 611, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdDisableDataThrottle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 611, value);
};


/**
 * optional bool tap_to_focus_rfd = 612;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTapToFocusRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 612, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTapToFocusRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 612, value);
};


/**
 * optional bool automatic_vexcel_dsm_ingest = 613;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getAutomaticVexcelDsmIngest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 613, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setAutomaticVexcelDsmIngest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 613, value);
};


/**
 * optional bool enable_multi_drone_rid = 614;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableMultiDroneRid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 614, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableMultiDroneRid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 614, value);
};


/**
 * optional bool part_107_certification = 615;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPart107Certification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 615, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPart107Certification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 615, value);
};


/**
 * optional bool enable_inline_marker_editing = 616;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableInlineMarkerEditing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 616, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableInlineMarkerEditing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 616, value);
};


/**
 * optional bool transparency_dashboard_v2 = 617;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTransparencyDashboardV2 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 617, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTransparencyDashboardV2 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 617, value);
};


/**
 * optional bool enable_out_of_service = 618;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableOutOfService = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 618, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableOutOfService = function(value) {
  return jspb.Message.setProto3BooleanField(this, 618, value);
};


/**
 * optional bool tag_settings_view = 619;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getTagSettingsView = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 619, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setTagSettingsView = function(value) {
  return jspb.Message.setProto3BooleanField(this, 619, value);
};


/**
 * optional bool mission_editor_nomad_map_dev_switch = 620;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getMissionEditorNomadMapDevSwitch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 620, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setMissionEditorNomadMapDevSwitch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 620, value);
};


/**
 * optional bool cloud_rtk_profile_api_key_support = 621;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getCloudRtkProfileApiKeySupport = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 621, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setCloudRtkProfileApiKeySupport = function(value) {
  return jspb.Message.setProto3BooleanField(this, 621, value);
};


/**
 * optional bool enable_periodic_bk_scan = 622;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePeriodicBkScan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 622, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePeriodicBkScan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 622, value);
};


/**
 * optional bool run_axon_poller_on_skypoller = 623;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRunAxonPollerOnSkypoller = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 623, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRunAxonPollerOnSkypoller = function(value) {
  return jspb.Message.setProto3BooleanField(this, 623, value);
};


/**
 * optional bool enable_global_airspace_deconfliction = 624;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableGlobalAirspaceDeconfliction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 624, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableGlobalAirspaceDeconfliction = function(value) {
  return jspb.Message.setProto3BooleanField(this, 624, value);
};


/**
 * optional bool show_sso_jit_toggle = 625;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowSsoJitToggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 625, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowSsoJitToggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 625, value);
};


/**
 * optional bool show_af_region_rfd = 626;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowAfRegionRfd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 626, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowAfRegionRfd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 626, value);
};


/**
 * optional bool consumables_v2_panel = 627;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getConsumablesV2Panel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 627, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setConsumablesV2Panel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 627, value);
};


/**
 * optional bool use_foundry_client = 628;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getUseFoundryClient = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 628, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setUseFoundryClient = function(value) {
  return jspb.Message.setProto3BooleanField(this, 628, value);
};


/**
 * optional bool enable_power_line_geofences = 629;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnablePowerLineGeofences = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 629, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnablePowerLineGeofences = function(value) {
  return jspb.Message.setProto3BooleanField(this, 629, value);
};


/**
 * optional bool enable_geo_lookat = 630;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableGeoLookat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 630, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableGeoLookat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 630, value);
};


/**
 * optional bool setup_scheduled_flights_from_cloud = 631;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getSetupScheduledFlightsFromCloud = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 631, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setSetupScheduledFlightsFromCloud = function(value) {
  return jspb.Message.setProto3BooleanField(this, 631, value);
};


/**
 * optional bool show_h265_toggle = 632;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getShowH265Toggle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 632, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setShowH265Toggle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 632, value);
};


/**
 * optional bool rfd_enable_controller_customization = 633;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdEnableControllerCustomization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 633, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdEnableControllerCustomization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 633, value);
};


/**
 * optional bool rg_scoped_integrations = 634;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRgScopedIntegrations = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 634, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRgScopedIntegrations = function(value) {
  return jspb.Message.setProto3BooleanField(this, 634, value);
};


/**
 * optional bool fusion_plus_ota = 635;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getFusionPlusOta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 635, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setFusionPlusOta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 635, value);
};


/**
 * optional bool enable_dock_circles_layer = 636;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDockCirclesLayer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 636, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDockCirclesLayer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 636, value);
};


/**
 * optional bool rfd_enable_rth_optimal_slider = 637;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getRfdEnableRthOptimalSlider = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 637, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setRfdEnableRthOptimalSlider = function(value) {
  return jspb.Message.setProto3BooleanField(this, 637, value);
};


/**
 * optional bool pre_release_feature_controls = 638;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getPreReleaseFeatureControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 638, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setPreReleaseFeatureControls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 638, value);
};


/**
 * optional bool enable_manual_clip_capture = 639;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableManualClipCapture = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 639, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableManualClipCapture = function(value) {
  return jspb.Message.setProto3BooleanField(this, 639, value);
};


/**
 * optional bool enable_weather_inference = 640;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableWeatherInference = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 640, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableWeatherInference = function(value) {
  return jspb.Message.setProto3BooleanField(this, 640, value);
};


/**
 * optional bool enable_drone_inspection_tracking = 641;
 * @return {boolean}
 */
proto.cloud_api.FeatureFlags.prototype.getEnableDroneInspectionTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 641, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.FeatureFlags} returns this
 */
proto.cloud_api.FeatureFlags.prototype.setEnableDroneInspectionTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 641, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.FeatureFlagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.FeatureFlagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.FeatureFlagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationPermission: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.FeatureFlagRequest}
 */
proto.cloud_api.FeatureFlagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.FeatureFlagRequest;
  return proto.cloud_api.FeatureFlagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.FeatureFlagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.FeatureFlagRequest}
 */
proto.cloud_api.FeatureFlagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrganizationId(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud_api.OrgPermission.PermEnum} */ (reader.readEnum());
      msg.setOrganizationPermission(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.FeatureFlagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.FeatureFlagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.FeatureFlagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.FeatureFlagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationPermission();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string organization_id = 1;
 * @return {string}
 */
proto.cloud_api.FeatureFlagRequest.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.FeatureFlagRequest} returns this
 */
proto.cloud_api.FeatureFlagRequest.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OrgPermission.PermEnum organization_permission = 2;
 * @return {!proto.cloud_api.OrgPermission.PermEnum}
 */
proto.cloud_api.FeatureFlagRequest.prototype.getOrganizationPermission = function() {
  return /** @type {!proto.cloud_api.OrgPermission.PermEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud_api.OrgPermission.PermEnum} value
 * @return {!proto.cloud_api.FeatureFlagRequest} returns this
 */
proto.cloud_api.FeatureFlagRequest.prototype.setOrganizationPermission = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.cloud_api);
